import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation, Inject, Injector } from '@angular/core';
import { Widget, TimelineSeries, TimelineData, Series, DataProvider, LogService, WidegtHelperService, TimelineDataCollection } from 'core-dashboard';
import * as d3 from 'd3';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'trend-series-multiaxis-chart',
  template: `<div style='width: 100%; float: right; background-color: #F2F2F2; '>
              <div class='d3-multi-chart-header' #multichartHeader style="float: right;margin-right: 50px;">

              <img style='border: none;background: none;width:20px;height:20px;padding-right:5px' src="assets/play3.png" *ngIf='!isLiveData' id='playBtn' (click)='startButtonClicked($event)'>
              <img style='border: none;background: none;width:20px;height:20px;padding-right:5px'  src="assets/pause3.png"  *ngIf='isLiveData' id='pauseBtn' (click)='startButtonClicked($event)'>
              <img style='border: none;background: none;opacity:1;width:20px;height:20px;' src="assets/refresh3.png" id='refreshBtn'  (click)='refreshButtonClicked($event)'>

              </div></div>
              <div class='d3-chart' #multichart  style="height:95%"></div>
              `,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./trendseries.multi.axis.chart.css']
})
export class TrendSeriesMultiAxisChart extends Widget implements OnInit {
  private nonArchivedTimelineData: TimelineData;
  private AarchivedCOVs: TimelineData;
  private isItFrom = "LOAD";
  private cachedDataToMaintain = -1;
  private isDataNotPresent = false;
  private isNonArchievedData = false;
  private xAxisScaleToMaintain: Date[];
  private GUID;
  //adding this field to refresh chart if previous refresh is done and then only we should refresh. 
  //if there is huge refresh and huge data present then it will take more than 3 sec to process and in that case it will fail.
  private isRefreshing = false;
  private intervalFun: any = -1;
  name: string;
  public isLiveData = true;
  private svg;
  private mainXAxisGroup;
  private mainYAxisGroup: any[] = [];
  private mainLinePath: any = [];
  private navXAxis;
  private navXAxisGroup;
  private brush;
  private missedData: any[] = [];
  private tooltipValues: TooltipValue[];
  private tooltipGroup;
  private leftLegend;
  private svgPercentageWidth = 100;
  private lineTooltiptextelement: any;
  private lineRect;
  private leftLegendWidth;
  private leftLegendHeight;
  //because of zoom feature, we need to maintain original data to start and refresh the chart
  //private timelineDataOriginal: TimelineData;
  private from: Date;
  private to: Date;
  private lineFocus: any;
  private isInitialLoad: boolean = true;
  private isDragStrated: boolean = false;
  private mouseLineScale = -1;
  private hasDummyData: number[] = [];
  data: any;
  private ERROR_TEXT = "Cannot Fetch Data for Chart!";
  private ERROR_TEXT_INVALID_RANGE = "No data found in the given time range.";
  private width: number;
  private colorArr: any;
  private height: number;
  private lastHeight: number;
  private lastWidth: number;
  private widgetStyle: any;
  private X_Max: any;
  private X_Min: any;
  private Y_Max: any[] = [];
  private Y_Resolution: any[] = [];
  private Unit: any[] = [];
  private Y_Min: any[] = [];
  private sortedData: any;
  private mainChart: any;
  private chart: any;
  private BottomOffset: number;
  private xScale: any;
  private yScale: any[] = [];
  private xAxis: any;
  private yAxis: any[] = [];
  private xIsDateTime = false;
  private yIsDateTime = false;
  private plotLine: any[] = [];
  private plotArea: any;
  private dataProvider: any;
  private colors: any[] = [];
  private xAxisLabelHeight = 0;
  private yLabelHeight = 0;
  private maxValueForYAxisLength = 0;
  private yLabelMaxValues: any[] = [];
  private maxValueForXAxisHeight = 0;
  private focus: any;
  private navFocus: any;
  private navStartLabel: Date;
  private navEndLabel: Date;
  private titleHeight = 0;
  private legendHeightoffset = 0;
  private legendAdjustmentFactor = 5;
  private navXScale: any;
  private navYScale: any;
  private bisectValueMin = d3.bisector((d: any) => { return d.X; }).left;
  private bisectValueMax = d3.bisector((d: any) => { return d.X; }).right;
  private STR_OBJECT = "Point Name";
  private STR_VALUE = "Value";
  private STR_TIME = "Timestamp";
  private MINUTES = "Minutes";
  private SECONDS = "Seconds";
  private HOURS = "Hours";
  private DAYS = "Days";
  private MILLISECONDS = "Milliseconds";
  private tooltiptextelement: any;
  private x_Oppacity: any;
  private circle: any;
  private config: any;
  private localeFormat: any;
  private dataUpdateTime: number = 0;

  private wheelDelta: number = 0;
  private mousePosX: number = 0;
  private multiplierForZoom: number = 24;
  private minZoomRangeInMins: number = 5;
  private zooming: boolean = false;
  private last_x_max: any;
  private last_x_min: any;
  private widgetDrawn: boolean = false;

  private defaultStyle: any =
    {
      "background-color": "#F2F2F2",

      "tooltip-background": "White",
      "tooltip-font-color": "Black",
      "tooltip-font": "Sans-serif",
      "tooltip-font-size": 10,

      "legend-font-color": "#37474F",
      "legend-font": "Sans-serif",
      "legend-font-size": 10,
      "legend-visible": true,
      "legend-position": "bottom",

      "title-visible": true,
      "title-font-color": "#efefef",
      "title-font": "Sans-serif",
      "title-font-size": 14,
      "title-background-color": "#404040",

      "error-font-color": "Red",
      "error-font": "Sans-serif",
      "error-font-size": 14,

      "colors": ["#D32F2F", "#303F9F", "#4CAF50", "#F57C00", "#C2185B", "#1976D2", "#CDDC39", "#7B1FA2", "#FFC107", "#00796B"],

      "x-axis-label": "X-AXIS",
      "y-axis-label": "Y-AXIS",
      "point-name-label": "POINT_NAME",
      "x-axis-color": "#37474F",
      "y-axis-color": "#37474F",
      "x-axis-font": "Sans-serif",
      "y-axis-font": "Sans-serif",
      "x-axis-font-size": 12,
      "y-axis-font-size": 12,
      "x-axis-label-visible": true,
      "y-axis-label-visible": true,
      "x-axis-line-oppacity": 25,

      "margin": {
        "left": 20,
        "top": 5,
        "right": 50,
        "bottom": 5
      }
    }

  constructor(@Inject('dataProvider') dataProvider: any, @Inject("widgetStyle") widgetStyle: any, private injector: Injector/*private parameters: ParameterService,private http:Http*/,
    logger: LogService, private widgetHelper: WidegtHelperService, translateService: TranslateService, @Inject("config") _config: any) {
    super(logger, translateService);
    this.widgetStyle = widgetStyle;
    this.dataProvider = dataProvider;
    this.config = _config;
    this.localeFormat = this.widgetHelper.getLocaleFormat(this.translateService.currentLang);
    //console.log("sid:"+ JSON.str this.localFormat.toString());
    this.applyStyles();
  }

  @ViewChild('multichart',{static: true}) private chartContainer: ElementRef;
  @ViewChild('multichartHeader',{static: true}) private chartHeader: ElementRef;

  ngOnInit() {
    try {
      if (this.dataProvider && (this.dataProvider.name !== "")) {
        this.setGUID();
        this.nonArchivedTimelineData = new TimelineData();
        this.nonArchivedTimelineData.Data = [];
        let element = this.chartContainer.nativeElement;
        let headerElement = this.chartHeader.nativeElement;
        d3.select(element).selectAll('#left-legend-container').style("display", "none");
        d3.select(headerElement).selectAll('#refreshBtn').style("opacity", "0.3");
        let provider = this.injector.get(this.dataProvider.name) as DataProvider;
        if (provider) {
          this.nonArchivedTimelineData = undefined;
          provider.getData(this);
        }
        else {
          let dataproviderName = (this.dataProvider) ? this.dataProvider.name : "";
          this.logger.logWarning("TrendSeriesMultiAxisChart", "Unable to instantiate dataprovider for chart. DataProvider name: " + dataproviderName);
          this.Draw(null);
        }
        let updateTimeSeconds = 0;
        if (this.config.liveDataUpdateTime != undefined && this.config.liveDataUpdateTime != null && !isNaN(parseFloat(this.config.liveDataUpdateTime))) {
          updateTimeSeconds = parseFloat(this.config.liveDataUpdateTime) * 1000;
        }
        this.dataUpdateTime = updateTimeSeconds > 2000 ? updateTimeSeconds : 2000;
        this.isRefreshing = false;
        if (this.intervalFun != -1) {
          clearInterval(this.intervalFun);
          this.intervalFun = -1;
        }
        this.intervalFun = setInterval(() => { this.interFunction(this) }, this.dataUpdateTime);
      }
    }
    catch (error) {
      this.logger.logError("TrendSeriesMultiAxisChart", "Error on ngOnInit. Error:" + error);
    }
  }
  interFunction(thisObj: TrendSeriesMultiAxisChart) {
    {
      try {
        if (!thisObj.isRefreshing && thisObj.data != undefined && thisObj.isItFrom != "ZOOM" && thisObj.isItFrom != "REF") {
          thisObj.isRefreshing = true;
          //this is to handle - if all dps are nona only and the chart is in live state
          //then, chart doesnt maintain chache as nonArchivedTimelineData is undefined
          if (thisObj.nonArchivedTimelineData == undefined) {
            thisObj.nonArchivedTimelineData = new TimelineData();
            thisObj.nonArchivedTimelineData.Data = [];
          }
          if (thisObj.nonArchivedTimelineData.Data.length <= 0) {
            try {
              for (var serCount = 0, _count = 0; serCount < thisObj.data.length; serCount++) {
                if (thisObj.data[serCount].Data[0].IsNonArchived) {
                  thisObj.nonArchivedTimelineData.Data[_count] = new TimelineSeries();
                  thisObj.nonArchivedTimelineData.Data[_count].DataPointName = thisObj.data[serCount].Data[0].DataPointName;
                  thisObj.nonArchivedTimelineData.Data[_count].IsNonArchived = thisObj.data[serCount].Data[0].IsNonArchived;
                  thisObj.nonArchivedTimelineData.Data[_count].Series = [new Series()];
                  thisObj.nonArchivedTimelineData.Data[_count].Series = thisObj.data[serCount].Data[0].Series.slice(0, thisObj.data[serCount].Data[0].Series.length);
                  thisObj.nonArchivedTimelineData.Data[_count].TrendSeriesId = thisObj.data[serCount].Data[0].TrendSeriesId;
                  thisObj.nonArchivedTimelineData.Data[_count].Unit = thisObj.data[serCount].Data[0].Unit;
                  thisObj.nonArchivedTimelineData.Data[_count].Resolution = thisObj.data[serCount].Data[0].Resolution;
                  thisObj.nonArchivedTimelineData.Data[_count].xMax = thisObj.data[serCount].Data[0].xMax;
                  thisObj.nonArchivedTimelineData.Data[_count].xMin = thisObj.data[serCount].Data[0].xMin;
                  thisObj.nonArchivedTimelineData.Data[_count].yMax = thisObj.data[serCount].Data[0].yMax;
                  thisObj.nonArchivedTimelineData.Data[_count].yMin = thisObj.data[serCount].Data[0].yMin;
                  _count++;
                }
              }
            } catch (error) {
              thisObj.logger.logError("setInterval", "Error on ngOnInit. Error:" + error);
            }
          }
          let provider = thisObj.injector.get(thisObj.dataProvider.name) as DataProvider;
          if (provider) {
            if (thisObj.isLiveData && thisObj.navXAxisGroup != undefined) {
              if (thisObj.data != undefined) {
                let reducedCovData = provider.getReducedCovData(thisObj.getTempReducedTimelineObj(false));
                //this should be before calculating borders, and hence moved up
                thisObj.xAxisScaleToMaintain = reducedCovData.xAxisScaleToMaintain;
                if (thisObj.xAxisScaleToMaintain.length == 2) {
                  let diff = new Date().getTime() - thisObj.xAxisScaleToMaintain[1].getTime();
                  thisObj.xAxisScaleToMaintain[0] = new Date(thisObj.xAxisScaleToMaintain[0].getTime() + diff);
                  thisObj.xAxisScaleToMaintain[1] = new Date();//new Date(thisObj.xAxisScaleToMaintain[1].getTime() + 2000); //adding 2000 to maintain the scale
                }
                thisObj.reduceData(reducedCovData, true, true);
                thisObj.setDataBoundries();

                thisObj.redrawMainChart();
                thisObj.redrawNavChart();
                //console.log("Redrawn chart: X_Max" + this.X_Max + " ,Y value: " + this.timelinedata.Data[0].Series[this.timelinedata.Data[0].Series.length - 1]);
              }
            }
            //To handle if there is no initial data present for any of the dp
            else if (thisObj.isLiveData && thisObj.isDataNotPresent) {
              let reducedCovData = provider.getReducedCovData(thisObj.getTempReducedTimelineObj(false));
              thisObj.reduceData(reducedCovData, true, true);

              //check if acutally data is present or not after reduction
              for (let c = 0; c < thisObj.data.length; c++) {
                if (thisObj.data[c].Data[0].Series.length > 0) {
                  thisObj.isDataNotPresent = false;
                  break;
                }
              }
              thisObj.xAxisScaleToMaintain = reducedCovData.xAxisScaleToMaintain;
              thisObj.isItFrom = "TIMER";
              thisObj.Draw(thisObj.data);
            }
          }
        }
      } catch (error) {
        thisObj.logger.logError("setInterval", "Error on setInterval. Error:" + error);
      }
      finally {
        thisObj.isRefreshing = false;
        thisObj.isItFrom = "LOAD";
      }

    }
  }
  setGUID() {
    if (this.GUID == undefined) {
      // this.GUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      this.GUID = '_xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
      this.logger.logInfo("NEW GUID", "" + this.GUID);
    }
    else {
      this.logger.logInfo("EXISTING GUID", "" + this.GUID);
    }
  }
  applyStyles() {
    if (typeof this.defaultStyle !== 'undefined') {
      for (let propName in this.defaultStyle) {
        var propertyName = propName.replace(/-/g, "_");
        let propValue = this.widgetStyle[propName];
        if (propValue !== undefined) {
          this.currentStyle[propertyName] = propValue;
        }
        else {
          this.currentStyle[propertyName] = this.defaultStyle[propName];
        }
      }
      this.x_Oppacity = this.currentStyle.x_axis_line_oppacity / 100;
    }

    this.logger.logInfo("TrendSeriesMultiAxisChart", " styles are: " + JSON.stringify(this.currentStyle));
  }
  reduceData(reducedCovData: any, isOnlyNonArchived: boolean, isTorefresh: boolean) {
    let seriesCount = 0;
    if (this.data !== undefined) {
      //for each time series
      this.data.forEach(series => {
        if (series.Data[0] !== undefined) {
          //for each reduced time series
          reducedCovData.data.Data.forEach(reducedSer => {

            //if trendseries id matches, then update data
            if (series.Data[0].TrendSeriesId == reducedSer.TrendSeriesId) {
              if (isOnlyNonArchived) {
                this.reduceNonaData(series.Data[0], reducedSer, isTorefresh);
              }
              else {
                //1. push data
                series.Data[0].Series.push(...reducedSer.Series);
              }

              //2. remove data
              for (let elementCount = 0; elementCount < series.Data[0].Series.length; elementCount++) {
                if (series.Data[0].Series[0].X.getTime() < reducedCovData.borders[seriesCount]) {
                  series.Data[0].Series.splice(0, 1);
                  //remogin elementes from series, so series length is reduced and hence we need to reduce the counter
                  elementCount--;
                }
                else {
                  break;
                }
              }
              //remove data for non archived only
              if (!isOnlyNonArchived && (series.IsNonArchived) || this.isThisNonArchivedNona(series.Data[0].TrendSeriesId)) {
                var areAllNonArchived = true;
                for (let tount = 0; tount < this.data.length; tount++) {
                  if (!this.data[tount].Data[0].IsNonArchived) {
                    areAllNonArchived = false;
                  }
                }
                if (areAllNonArchived) {
                  //REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
                  this.removeOlderDataFromCacheForNonArchived(series.Data[0], new Date());
                }
              }
              //set min and max
              if (series.Data[0].Series.length > 0) {
                series.Data[0].xMax = d3.max(series.Data[0].Series, function (d) { return d["X"]; });
                series.Data[0].xMin = d3.min(series.Data[0].Series, function (d) { return d["X"]; });
              }
            }
            //removes series data for which new data is not added but this series has older data than lborder
            //means, it should not have && reducedSer.Series.length > 0 condition
            //removed = sign from series.Series[0].X <= reducedCovData.borders[seriesCount] as this was removing data for which we dont have any data for any series
            else if (series.Data[0].TrendSeriesId == reducedSer.TrendSeriesId && series.Data[0].Series.length > 0 && series.Data[0].Series[0].X.getTime() < reducedCovData.borders[seriesCount]) {
              for (let elementCount = 0; elementCount < series.Data[0].Series.length; elementCount++) {
                if (series.Data[0].Series[0].X.getTime() < reducedCovData.borders[seriesCount]) {
                  series.Data[0].Series.splice(0, 1);
                  //remogin elementes from series, so series length is reduced and hence we need to reduce the counter
                  elementCount--;
                }
                else {
                  break;
                }
              }
              //remove data for non archived only
              if (!isOnlyNonArchived && (series.IsNonArchived) || this.isThisNonArchivedNona(series.Data[0].TrendSeriesId)) {
                //REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
                this.removeOlderDataFromCacheForNonArchived(series.Data[0], new Date());
              }
            }
            //series.Data[0].Series.splice(0, reducedCovData.numberOfItemsToRemove[seriesCount]);
          });
          seriesCount++;
        }
      });
    }
  }
  reduceNonaData(series: TimelineSeries, reducedSer: TimelineSeries, isTorefresh: boolean) {
    try {

      //A. if in last week it was non archived and now also it is non archived
      if ((this.nonArchivedTimelineData != undefined && this.isThisNonArchivedNona(series.TrendSeriesId) && series.IsNonArchived)) {
        try {
          for (let tCount = 0; tCount < this.nonArchivedTimelineData.Data.length; tCount++) {
            if (this.nonArchivedTimelineData.Data[tCount].TrendSeriesId == series.TrendSeriesId && this.nonArchivedTimelineData.Data[tCount].IsNonArchived) {
              //1. Remove overlapping
              for (let cc = 0; cc < reducedSer.Series.length;) {
                if (this.nonArchivedTimelineData.Data[tCount].Series.length > 0 && this.nonArchivedTimelineData.Data[tCount].Series.length > 0 &&
                  reducedSer.Series[0].X < this.nonArchivedTimelineData.Data[tCount].Series[this.nonArchivedTimelineData.Data[tCount].Series.length - 1].X) {
                  reducedSer.Series.splice(0, 1);
                }
                else {
                  cc++
                  break;
                }
              }

              //2. merge data - merge cache and cov's
              if (reducedSer.Series != undefined && reducedSer.Series.length > 0)
                this.nonArchivedTimelineData.Data[tCount].Series.push(...reducedSer.Series.slice(0, reducedSer.Series.length));

              //3. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
              this.removeOlderDataFromCacheForNonArchived(this.nonArchivedTimelineData.Data[tCount], new Date());

              for (let cc = series.Series.length - 1; cc >= 0; cc--) {
                if (cc >= 0 &&
                  series.Series[cc].X > this.nonArchivedTimelineData.Data[tCount].Series[0].X && series.Series[cc].X > this.xAxisScaleToMaintain[0] && series.Series[cc].X < this.xAxisScaleToMaintain[1]) {
                  series.Series.splice(cc, 1);
                }
                else {
                  cc--
                  break;
                }
              }

              //3. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
              this.removeOlderDataFromCacheForNonArchived(series, new Date());

              //4. push cov's
              if (this.nonArchivedTimelineData.Data[tCount].Series != undefined && this.nonArchivedTimelineData.Data[tCount].Series.length > 0)
                series.Series.push(...this.nonArchivedTimelineData.Data[tCount].Series.slice(0, this.nonArchivedTimelineData.Data[tCount].Series.length));

              //5. REMOVE OUT OF RANGE DATA
              this.removeOutOfRangeData(series);
              break;
            }
          }
        } catch (error) {
          this.logger.logError("TrendSeriesChart", "A condition - Error reducing the data for NONA support: " + error);
        }

      }
      //B. if in last week it was non archived and now it is archived. this can be something 
      //if in last week it was non archived and now it is archived
      else if ((this.nonArchivedTimelineData != undefined && this.isThisNonArchivedNona(series.TrendSeriesId) && !series.IsNonArchived)) {
        try {
          for (let tCount = 0; tCount < this.nonArchivedTimelineData.Data.length; tCount++) {
            if (this.nonArchivedTimelineData.Data[tCount].TrendSeriesId == series.TrendSeriesId && this.nonArchivedTimelineData.Data[tCount].IsNonArchived) {

              try {
                //sequence of data - history, cache and covs
                if (series.Series.length > 0 && this.nonArchivedTimelineData.Data.length > 0 && this.nonArchivedTimelineData.Data[tCount].Series.length > 0 &&
                  series.Series[0].X < this.nonArchivedTimelineData.Data[tCount].Series[0].X) {

                  try {
                    //1. Remove overlapping data from cache. remove the last item
                    for (let cc = series.Series.length - 1; cc >= 0; cc--) {
                      if (series.Series.length > 0 && this.nonArchivedTimelineData.Data[tCount].Series.length > 0 &&
                        series.Series[cc].X > this.nonArchivedTimelineData.Data[tCount].Series[0].X &&
                        series.Series[cc].X > this.xAxisScaleToMaintain[0] && series.Series[cc].X < this.xAxisScaleToMaintain[1]) {
                        series.Series.splice(cc, 1);
                      }
                      else {
                        cc--
                        break;
                      }
                    }

                    for (let cc = 0; cc < this.nonArchivedTimelineData.Data[tCount].Series.length;) {
                      if (this.nonArchivedTimelineData.Data[tCount].Series.length > 0 && reducedSer.Series.length > 0 &&
                        this.nonArchivedTimelineData.Data[tCount].Series[this.nonArchivedTimelineData.Data[tCount].Series.length - 1].X > reducedSer.Series[0].X) {
                        reducedSer.Series.splice(0, 1);
                      }
                      else {
                        cc++
                        break;
                      }
                    }

                    //3. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
                    this.removeOlderDataFromCacheForNonArchived(this.nonArchivedTimelineData.Data[tCount], new Date());
                    //4. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
                    this.removeOlderDataFromCacheForNonArchived(reducedSer, new Date());

                    //5. push cache, history and cov's to timeline
                    if (reducedSer.Series != undefined && reducedSer.Series.length > 0)
                      this.nonArchivedTimelineData.Data[tCount].Series.push(...reducedSer.Series.slice(0, reducedSer.Series.length));

                    if (this.nonArchivedTimelineData.Data[tCount].Series != undefined && this.nonArchivedTimelineData.Data[tCount].Series.length > 0)
                      series.Series.push(... this.nonArchivedTimelineData.Data[tCount].Series.slice(0, this.nonArchivedTimelineData.Data[tCount].Series.length));

                  } catch (error) {
                    this.logger.logError("TrendSeriesChart", "B condition If log - Error reducing the data for NONA support: " + error);
                  }

                }
                //sequence of data -  cache, history and covs
                else {

                  try {
                    //1. Remove overlapping data from cache. remove the last item
                    for (let cc = this.nonArchivedTimelineData.Data[tCount].Series.length - 1; cc >= 0;) {
                      if (cc >= 0 && series.Series.length > 0 &&
                        series.Series[0].X < this.nonArchivedTimelineData.Data[tCount].Series[cc].X && series.Series[0].X > this.xAxisScaleToMaintain[0] && series.Series[0].X < this.xAxisScaleToMaintain[1]) {
                        series.Series.splice(0, 1);
                      }
                      else {
                        cc--
                        break;
                      }
                    }

                    for (let cc = 0; cc < series.Series.length;) {
                      if (series.Series.length > 0 && reducedSer.Series.length > 0 &&
                        series.Series[series.Series.length - 1].X > reducedSer.Series[0].X) {
                        reducedSer.Series.splice(0, 1);
                      }
                      else {
                        cc++
                        break;
                      }
                    }

                    //3. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
                    this.removeOlderDataFromCacheForNonArchived(this.nonArchivedTimelineData.Data[tCount], new Date());
                    //4. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
                    this.removeOlderDataFromCacheForNonArchived(reducedSer, new Date());

                    //5. push cache, history and cov's to timeline
                    var tempArray = [];
                    if (this.nonArchivedTimelineData.Data[tCount].Series != undefined && this.nonArchivedTimelineData.Data[tCount].Series.length > 0)
                      tempArray.push(...this.nonArchivedTimelineData.Data[tCount].Series.slice(0, this.nonArchivedTimelineData.Data[tCount].Series.length));
                    if (series.Series != undefined && series.Series.length > 0)
                      tempArray.push(...series.Series.slice(0, series.Series.length));
                    if (reducedSer.Series != undefined && reducedSer.Series.length > 0)
                      tempArray.push(...reducedSer.Series.slice(0, reducedSer.Series.length));
                    series.Series = tempArray;

                    //set cov's to cache. this is replacing the oldest cache by latest cov's 
                    this.nonArchivedTimelineData.Data[tCount].Series = reducedSer.Series;//.push(...this.nonArchivedTimelineData.Data[tCount].Series);
                  } catch (error) {
                    this.logger.logError("TrendSeriesChart", "B condition else log - Error reducing the data for NONA support: " + error);
                  }

                }
              } catch (error) {
                this.logger.logError("TrendSeriesChart", "B condition parent log - Error reducing the data for NONA support: " + error);
              }


              //6. REMOVE OUT OF RANGE DATA
              this.removeOutOfRangeData(series);
              break;
            }
          }
        } catch (error) {
          this.logger.logError("TrendSeriesChart", "B condition - Error reducing the data for NONA support: " + error);
        }

      }
      //C. if in last week it was archived and now it is non archived. series is empty list
      else if ((this.nonArchivedTimelineData != undefined && !this.isThisNonArchivedNona(series.TrendSeriesId) && (series.IsNonArchived))) {
        try {
          //1. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
          this.removeOlderDataFromCacheForNonArchived(reducedSer, new Date());

          //2. check if same trend already present in cache. mostly it is not
          var isFOund = false;
          for (let tCount = 0; tCount < this.nonArchivedTimelineData.Data.length; tCount++) {
            if (this.nonArchivedTimelineData.Data[tCount].TrendSeriesId == series.TrendSeriesId) {
              isFOund = true;
            }
          }
          //3. push cov's to cache
          if (!isFOund) {
            this.nonArchivedTimelineData.Data[this.nonArchivedTimelineData.Data.length] = reducedSer;
            this.nonArchivedTimelineData.Data[this.nonArchivedTimelineData.Data.length - 1].IsNonArchived = true;
            for (let cc = 0; cc < reducedSer.Series.length;) {
              if (series.Series.length > 0 && reducedSer.Series.length > 0 &&
                series.Series[series.Series.length - 1].X > reducedSer.Series[0].X) {
                reducedSer.Series.splice(0, 1);
              }
              else {
                cc++
                break;
              }
            }
            //4. push cov's to timeline
            if (reducedSer.Series != undefined && reducedSer.Series.length > 0)
              series.Series.push(...reducedSer.Series.slice(0, reducedSer.Series.length));
          }
          //5. REMOVE OUT OF RANGE DATA
          this.removeOutOfRangeData(series);
        } catch (error) {
          this.logger.logError("TrendSeriesChart", "C condition - Error reducing the data for NONA support: " + error);
        }

      }
      //D. if in last week it was archived and now also it is  archived
      else if ((this.nonArchivedTimelineData != undefined && !this.isThisNonArchivedNona(series.TrendSeriesId) && !series.IsNonArchived)) {
        try {
          //1. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
          this.removeOlderDataFromCacheForNonArchived(reducedSer, new Date());

          for (let cc = series.Series.length - 1; cc >= 0; cc--) {
            if (cc >= 0 && reducedSer.Series.length > 0 &&
              //commented this as overlapping of data was happening
              //series.Series[cc].X > reducedSer.Series[0].X && series.Series[cc].X > this.xAxisScaleToMaintain[0] && series.Series[cc].X < this.xAxisScaleToMaintain[1]){
              series.Series[cc].X > reducedSer.Series[0].X) {
              series.Series.splice(cc, 1);
            }
            else {
              cc--
              break;
            }
          }
          //2. push data
          if (reducedSer.Series.length > 0)
            series.Series.push(...reducedSer.Series.slice(0, reducedSer.Series.length));

          //3. REMOVE OUT OF RANGE DATA
          this.removeOutOfRangeData(series);
        } catch (error) {
          this.logger.logError("TrendSeriesChart", "D condition - Error reducing the data for NONA support: " + error);
        }

      }
      //e. EVERY COV'S
      else {
        try {
          if (series.IsNonArchived) {
            this.removeOlderDataFromCacheForNonArchived(series, new Date());
          }
          //1. REMOVE THE OLDER DATA THAT IS OUT OF PREDEFINED CACHE RANGE
          this.removeOlderDataFromCacheForNonArchived(reducedSer, new Date());

          for (let cc = series.Series.length - 1; cc >= 0; cc--) {
            if (cc >= 0 && reducedSer.Series.length > 0 &&
              series.Series[cc].X > reducedSer.Series[0].X && series.Series[cc].X > this.xAxisScaleToMaintain[0] && series.Series[cc].X < this.xAxisScaleToMaintain[1]) {
              series.Series.splice(cc, 1);
            }
            else {
              cc--
              break;
            }
          }

          // //2. push data
          if (reducedSer.Series != undefined && reducedSer.Series.length > 0)
            series.Series.push(...reducedSer.Series.slice(0, reducedSer.Series.length));
        } catch (error) {
          this.logger.logError("TrendSeriesChart", "else condition - Error reducing the data for NONA support: " + error);
        }
      }

    } catch (error) {
      this.logger.logError("TrendSeriesChart", "Error reducing the data for NONA support: " + error);
    }
  }
  removeOutOfRangeData(series: TimelineSeries) {
    for (let elementCount = 0; elementCount < series.Series.length; elementCount++) {
      if (series.Series.length > 0 &&
        series.Series[0].X.getTime() < this.xAxisScaleToMaintain[0]) {
        series.Series.splice(0, 1);
        //this.logger.logInfo("reduceNonaData", "A condition -REMOVE OUT OF RANGE DATA 1");
        //remogin elementes from series, so series length is reduced and hence we need to reduce the counter
        elementCount--;
      }
      else {
        break;
      }
    }
    for (let elementCount = series.Series.length - 1; elementCount >= 0;) {
      if (series.Series.length > 0 &&
        series.Series[elementCount].X.getTime() > this.xAxisScaleToMaintain[1]) {
        series.Series.splice(elementCount, 1);
        //this.logger.logInfo("reduceNonaData", "A condition - REMOVE OUT OF RANGE DATA 2");
        //remogin elementes from series, so series length is reduced and hence we need to reduce the counter
        elementCount--;
      }
      else {
        break;
      }
    }
  }
  getTempReducedTimelineObj(isOnlyNoArchived: boolean) {
    let tempTimelineData: TimelineData = new TimelineData();
    let timelineObj = { data: tempTimelineData, isOnlyNonArchived: isOnlyNoArchived, NonaTrends: this.nonArchivedTimelineData, isItFrom: this.isItFrom }
    tempTimelineData.Data = [];
    //timelinedata is data received from database amd for nona this will be empty series
    if (this.data != undefined) {
      this.data.forEach(series => {
        let ser: TimelineSeries = new TimelineSeries();
        ser.DataPointName = series.Data[0].DataPointName;
        ser.TrendSeriesId = series.Data[0].TrendSeriesId;
        ser.IsNonArchived = series.Data[0].IsNonArchived;
        ser.Series = [];
        if (series.Data[0].Series.length > 0)
          ser.xMax = series.Data[0].Series[series.Data[0].Series.length - 1].X;
        //updated this code for BTQ BTQ00330216 and BTQ00330218
        //this was causing that, it was returning data for first series only and not for the series with bigger interval
        //the reason is, if the trend doesnt have data, then we should check if data is present in cache or from and then last option should be xMax
        //xMax is alwasy max/right side of chart and because of this reduction algorithm fails and hence updated
        else {
          let isAnyNonArchivedTrend = false;
          if (this.nonArchivedTimelineData != undefined) {
            for (let tCount = 0; tCount < this.nonArchivedTimelineData.Data.length; tCount++) {
              if (this.nonArchivedTimelineData.Data[tCount].TrendSeriesId == ser.TrendSeriesId && this.nonArchivedTimelineData.Data[tCount].xMax != undefined) {
                isAnyNonArchivedTrend = true;
                ser.xMax = this.nonArchivedTimelineData.Data[tCount].xMax;
                break;
              }
            }
          }
          if (!isAnyNonArchivedTrend && this.from != undefined) {
            ser.xMax = this.from;//series.Series[series.Series.length - 1].X;
          }
          else if (!isAnyNonArchivedTrend) {
            ser.xMax = this.X_Max;//series.Series[series.Series.length - 1].X;
          }
        }
        tempTimelineData.Data.push(ser);
      });
    }
    return timelineObj;
  }
  areAllArchived(data: any) {
    var areAllArchived = true;
    data.timelineData.Data.forEach(element => {
      if (element.IsNonArchived)
        areAllArchived = false;
    });
    return areAllArchived;
  }
  areAllNonArchived(data: any) {
    var areAllNonArchived = true;
    data.timelineData.Data.forEach(element => {
      if (!element.IsNonArchived)
        areAllNonArchived = false;
    });
    return areAllNonArchived;
  }
  Draw(data: any) {
    this.logger.logInfo("TrendSeriesMultiAxisChart", "Received callback from dataprovider. Drawing chart");
    this.hasDummyData = [];
    try {
      //this change is required only for multi y axis chart
      //because of first line, was failing for nona on zoom out
      //because of second line, failing to - REMOVED FOOLLOWING LINE AS because of this this chart was not able to load non archived only on initial load. 
      //if((data != undefined && data != null && data.timelineData != undefined && this.zooming && data.timelineData.Data.length != 0 && !this.areAllNonArchived(data))||
      if ((data != undefined && data != null && data.timelineData != undefined && this.zooming && data.timelineData.Data.length != 0) ||
        //          (data != undefined && data != null && data.timelineData != undefined && this.isInitialLoad && data.timelineData.Data.length != 0 && !this.areAllNonArchived(data)))
        (data != undefined && data != null && data.timelineData != undefined && this.isInitialLoad && data.timelineData.Data.length != 0)) {
        //let data = {timelineData: this.timelineData , isLive:this.isLive, from:this.From, to:this.To};
        if (data.timelineData == undefined) {
          this.data = data as TimelineData;
        }
        else {
          this.data = data.timelineData as TimelineData;
          this.from = data.from;
          this.to = data.to;
          if (!data.isLive) {
            this.isLiveData = false;
            this.svgPercentageWidth = 84;

            try {
              if (this.intervalFun != -1) {
                clearInterval(this.intervalFun);
                this.intervalFun = -1;
              }
            } catch (error) {
              this.logger.logError("handleArchivedAndNonArchived", "Error while clearing the interval..." + error);
            }

            //duplicate the non archived data points data in this.nonArchivedTimelineData
            //to use at the time of start button click
            if (this.nonArchivedTimelineData == undefined) {
              this.nonArchivedTimelineData = new TimelineData();
              this.nonArchivedTimelineData.Data = [];
            }
            if (this.nonArchivedTimelineData.Data.length <= 0) {
              if (this.data.length == undefined) {
                for (var serCount = 0, _count = 0; serCount < this.data.Data.length; serCount++) {
                  if (this.data.Data[serCount].IsNonArchived && this.data.Data[serCount].Series.length > 0) {
                    this.nonArchivedTimelineData.Data[_count] = new TimelineSeries();
                    this.nonArchivedTimelineData.Data[_count].DataPointName = this.data.Data[serCount].DataPointName;
                    this.nonArchivedTimelineData.Data[_count].IsNonArchived = this.data.Data[serCount].IsNonArchived;
                    this.nonArchivedTimelineData.Data[_count].Series = [new Series()];
                    this.nonArchivedTimelineData.Data[_count].Series = this.data.Data[serCount].Series.slice(0, this.data.Data[serCount].Series.length);
                    this.nonArchivedTimelineData.Data[_count].TrendSeriesId = this.data.Data[serCount].TrendSeriesId;
                    this.nonArchivedTimelineData.Data[_count].Unit = this.data.Data[serCount].Unit;
                    this.nonArchivedTimelineData.Data[_count].Resolution = this.data.Data[serCount].Resolution;
                    this.nonArchivedTimelineData.Data[_count].xMax = this.data.Data[serCount].xMax;
                    this.nonArchivedTimelineData.Data[_count].xMin = this.data.Data[serCount].xMin;
                    this.nonArchivedTimelineData.Data[_count].yMax = this.data.Data[serCount].yMax;
                    this.nonArchivedTimelineData.Data[_count].yMin = this.data.Data[serCount].yMin;
                    _count++;
                  }
                }
              }
              else {
                for (var serCount = 0, _count = 0; serCount < this.data.length; serCount++) {
                  if (this.data[serCount].Data[0].IsNonArchived && this.data[serCount].Data[0].Series.length > 0) {
                    this.nonArchivedTimelineData.Data[_count] = new TimelineSeries();
                    this.nonArchivedTimelineData.Data[_count].DataPointName = this.data[serCount].Data[0].DataPointName;
                    this.nonArchivedTimelineData.Data[_count].IsNonArchived = this.data[serCount].Data[0].IsNonArchived;
                    this.nonArchivedTimelineData.Data[_count].Series = [new Series()];
                    this.nonArchivedTimelineData.Data[_count].Series = this.data[serCount].Data[0].Series.slice(0, this.data[serCount].Data[0].Series.length);
                    this.nonArchivedTimelineData.Data[_count].TrendSeriesId = this.data[serCount].Data[0].TrendSeriesId;
                    this.nonArchivedTimelineData.Data[_count].Unit = this.data[serCount].Data[0].Unit;
                    this.nonArchivedTimelineData.Data[_count].Resolution = this.data[serCount].Data[0].Resolution;
                    this.nonArchivedTimelineData.Data[_count].xMax = this.data[serCount].Data[0].xMax;
                    this.nonArchivedTimelineData.Data[_count].xMin = this.data[serCount].Data[0].xMin;
                    this.nonArchivedTimelineData.Data[_count].yMax = this.data[serCount].Data[0].yMax;
                    this.nonArchivedTimelineData.Data[_count].yMin = this.data[serCount].Data[0].yMin;
                    _count++;
                  }
                }
              }
            }

            let headerElement = this.chartHeader.nativeElement;
            d3.select(headerElement).selectAll('#refreshBtn').style("opacity", "1");
          }
        }
        this.data = this.getTimelineData(this.data);
        this.handleArchivedAndNonArchived(data);
        //console.log("New Data on zoom with length : " + this.data[0].Data[0].Series.length);
      }
      //call is from pause click and hence it has already data present.
      else if (data != undefined && data != null && data.timelineData == undefined && (this.zooming || this.isInitialLoad) && data.from == undefined) {
        this.data = data as TimelineData;
      }
      //call is from provider and if it doesnt have data for provided from and to date.
      //then we will assign data = previous data. from date is not undefined means that we received call from provider and hence
      //we will plot old data
      //this condition is executed for zoom in and zoom out if there is no data present for provided from and to dates
      //reverted following line as for all non archived, zoom out was not working at all
      //else if (data != undefined && data != null && (data.timelineData == undefined || this.areAllNonArchived(data)) && (this.zooming || this.isInitialLoad)  && data.from != undefined) {
      else if (data != undefined && data != null && data.timelineData == undefined && (this.zooming || this.isInitialLoad) && data.from != undefined) {
        this.data = this.data;//data.timelineData as TimelineData;
      }
      //call is from provider and hence has all required params
      else {
        //console.log("Failed to get new data on zoom");
        this.data = data;
      }

      if (this.data != undefined && this.data != null && this.data.length != 0) {

        let datanotpresent = true;
        this.data.forEach(ts => {
          datanotpresent = datanotpresent && (ts.Data[0].Series.length == 0);
        });
        if (datanotpresent) {
          // this.drawErrorChart(this.ERROR_TEXT_INVALID_RANGE)
          this.data.forEach((ts,index) => {
            this.hasDummyData.push(index + 1);
            ts.Data[0].Series.push({ X: ts.Data[0].xMin !== undefined ? ts.Data[0].xMin : this.last_x_min, Y: 0 });
            ts.Data[0].Series.push({ X: ts.Data[0].xMax !== undefined ? ts.Data[0].xMax : this.last_x_max, Y: 0 });
          });
        }
        // this.colorArr = d3.scaleLinear().domain([0, this.data.length - 1]).range(<any[]>[this.currentStyle.start_color, this.currentStyle.end_color]);;
        this.lastHeight = 0;
        this.lastWidth = 0;
        for (let i = 0; i < this.data.length; i++) {
          this.colors = this.currentStyle.colors;
          this.Y_Resolution[i] = this.data[i].Data[0].Resolution;
          this.Unit[i] = this.data[i].Data[0].Unit;
        }
        if (this.data.length != 0) {
          this.createChart();
          this.enableDisableBrush();
        }

      }
      else {
        this.drawErrorChart(this.ERROR_TEXT);
        return;
      }
    }
    catch (error) {
      this.logger.logError("TrendSeriesMultiAxisChart", "error while drawing line series chart. Error: " + error);
    }
    finally {
      if (this.isItFrom == "START") {
        if (this.intervalFun != -1) {
          clearInterval(this.intervalFun);
          this.intervalFun = -1;
        }
        this.intervalFun = setInterval(() => { this.interFunction(this) }, this.dataUpdateTime);
      }
      if (this.isItFrom != "LOAD") {
        this.isItFrom = "LOAD"
      }
    }
  }
  private isAnyArchivedTrendPresent() {
    let isAnyNonArchivedTrend = false;
    for (let tCount = 0; tCount < this.data.length; tCount++) {
      if (this.data[tCount].Data[0].IsNonArchived) {
        isAnyNonArchivedTrend = true;
        break;
      }
    }
    if (!isAnyNonArchivedTrend) {
      for (let tCount = 0; tCount < this.nonArchivedTimelineData.Data.length; tCount++) {
        if (this.nonArchivedTimelineData.Data[tCount].IsNonArchived) {
          isAnyNonArchivedTrend = true;
          break;
        }
      }
    }
    return isAnyNonArchivedTrend;
  }
  //this condition is to handle if there are all NONA and there is some COV data in live 
  //user clicks on pause and then clicks on Zoom out, it was showing No data as all trends are NONA
  //we need to show NONA data and COV's
  private handleIfAllTrendsNona() {
    try {
      for (let tount = 0; tount < this.data.length; tount++) {
        for (var nonArchCount = 0; nonArchCount < this.nonArchivedTimelineData.Data.length; nonArchCount++) {
          if (this.data[tount].Data[0].TrendSeriesId == this.nonArchivedTimelineData.Data[nonArchCount].TrendSeriesId) {
            this.data[tount].Data[0].Series = this.nonArchivedTimelineData.Data[nonArchCount].Series;
            //set min and max
            if (this.data[tount].Data[0].Series.length > 0) {
              this.data[tount].Data[0].xMax = d3.max(this.data[tount].Data[0].Series, function (d) { return d["X"]; });
              this.data[tount].Data[0].xMin = d3.min(this.data[tount].Data[0].Series, function (d) { return d["X"]; });
            }
            break;
          }
        }
      }
    }
    catch (error) {
      this.logger.logError("NONA #3", "Error while adding: " + error);
    }
  }
  private prepareForNonaHandling(data: any) {
    this.isDataNotPresent = data.isDataNotPresent;
    this.xAxisScaleToMaintain = data.xAxisScaleToMaintain;
    this.cachedDataToMaintain = data.cachedDataToMaintain;

    if (this.xAxisScaleToMaintain.length == 2) {
      this.from = this.xAxisScaleToMaintain[0];
      this.to = this.xAxisScaleToMaintain[1];
    }
    else {
      this.from = data.from;
      this.to = data.to;
    }
    if (this.isItFrom == "ZOOM") {
      //if in last week it was archived and now it is non archived
      //add non archived data point to cache
      for (let tount = 0; tount < this.data.length; tount++) {
        for (let tCount = 0; tCount < this.nonArchivedTimelineData.Data.length; tCount++) {
          if (this.data[tount].Data[0].IsNonArchived != undefined && this.nonArchivedTimelineData != undefined && this.data[tount].Data[0].IsNonArchived && !this.isThisNonArchivedNona(this.data[tount].Data[0].TrendSeriesId)) {
            this.nonArchivedTimelineData.Data[this.nonArchivedTimelineData.Data.length] = this.data[tount].Data[0];
            break;
          }
        }
      }
    }
    if ((this.isItFrom == "START" || this.isItFrom == "REF") && this.nonArchivedTimelineData.Data.length > 0) {
      if (this.isItFrom == "REF") {
        //if in last week it was archived and now it is non archived
        for (let tount = 0; tount < this.data.length; tount++) {
          for (let tCount = 0; tCount < this.nonArchivedTimelineData.Data.length; tCount++) {
            if (this.data[tount].Data[0].IsNonArchived != undefined && this.nonArchivedTimelineData != undefined && this.data[tount].Data[0].IsNonArchived && !this.isThisNonArchivedNona(this.data[tount].Data[0].TrendSeriesId)) {
              this.nonArchivedTimelineData.Data[this.nonArchivedTimelineData.Data.length] = this.data[tount].Data[0];
              break;
            }
          }
        }
      }
    }
  }
  //function to remove the older that from cache for Non archiched data points
  private removeOlderDataFromCacheForNonArchived(series: TimelineSeries, currentTime: Date) {
    for (let itemCount = 0; itemCount < series.Series.length;) {
      //if trend found, remove the COv's those are reduced
      if (this.cachedDataToMaintain != -1 && (currentTime.getTime() - series.Series[0].X.getTime()) > this.cachedDataToMaintain) {
        series.Series.splice(0, 1);
      }
      //if not reduced, then dont remove so that we can reduce it in next reduction
      else {
        itemCount++;
        break;
      }
    }
  }
  private isThisNonArchivedNona(trendId: string) {
    let isAnyNonArchivedTrend = false;
    if (this.nonArchivedTimelineData != undefined) {
      for (let tCount = 0; tCount < this.nonArchivedTimelineData.Data.length; tCount++) {
        if (this.nonArchivedTimelineData.Data[tCount].TrendSeriesId == trendId && this.nonArchivedTimelineData.Data[tCount].IsNonArchived) {
          isAnyNonArchivedTrend = true;
          break;
        }
      }
    }
    return isAnyNonArchivedTrend;
  }
  private handleArchivedAndNonArchived(data: any) {
    try {
      this.prepareForNonaHandling(data);
      //On PAUSE, dont do anything
      if (this.isItFrom == "PAUSE") {
        //dont do anything      
      }
      //dont wanted execute this logic when user clicks on Pause
      else if (this.isItFrom != "LOAD") {
        let isAnyNonArchivedTrend = this.isAnyArchivedTrendPresent();
        if (isAnyNonArchivedTrend) {
          try {
            let provider = this.injector.get(this.dataProvider.name) as DataProvider;
            if (provider) {
              let reducedCovData = provider.getReducedCovData(this.getTempReducedTimelineObj(true));
              this.reduceData(reducedCovData, true, false);
              //Added START check to handle data loss on pause button
              //removed following commendted START check as it was failing in DCC when user clicks on start button.
              //on refresh it was not showing anything but it stack overflow was happening
              //if((this.isItFrom == "ZOOM" || this.isItFrom == "REF" || this.isItFrom == "START") && this.nonArchivedTimelineData != undefined && this.nonArchivedTimelineData.Data != undefined 
              if ((this.isItFrom == "ZOOM" || this.isItFrom == "REF") && this.nonArchivedTimelineData != undefined && this.nonArchivedTimelineData.Data != undefined
                && this.nonArchivedTimelineData.Data.length > 0 && this.nonArchivedTimelineData.Data.length == this.data.length) {
                var areAllNonArchived = true;
                for (let tount = 0; tount < this.data.length; tount++) {
                  if (!this.data[tount].Data[0].IsNonArchived) {
                    areAllNonArchived = false;
                  }
                }
                if (areAllNonArchived)
                  this.handleIfAllTrendsNona();



              }
              this.setDataBoundries();
              //now the this.timelinedata is reduced data merged covs & HDB
            }
          }
          catch (error) {
            this.logger.logError("TrendSeriesChart", "Error while merging the NONA and reduced data: " + error);
          }
        }
        //trend was archived previously and now it is non archived
        else {
        }
      }
    } catch (error) {
      this.logger.logError("handleArchivedAndNonArchived", "error while handling archived and non archived data. Error: " + error);
    }
  }

  private enableDisableBrush() {
    if (this.isLiveData && this.navXAxisGroup != undefined) {
      this.navXAxisGroup.selectAll('.selection').attr("cursor", "pointer");
      this.navXAxisGroup.selectAll('.handle.handle--e').attr("cursor", "pointer");
      this.navXAxisGroup.selectAll('.handle.handle--w').attr("cursor", "pointer");
    }
    else if (!this.isLiveData && this.navXAxisGroup != undefined) {
      this.navXAxisGroup.selectAll('.selection').attr("cursor", "move");
      this.navXAxisGroup.selectAll('.handle.handle--e').attr("cursor", "ew-resize");
      this.navXAxisGroup.selectAll('.handle.handle--w').attr("cursor", "ew-resize");
    }
  }
  public startButtonClicked(event) {
    this.isInitialLoad = false;
    try {
      if (this.data == undefined) {
        d3.event.sourceEvent.stopPropagation();
      }
      let element = this.chartContainer.nativeElement;
      let headerElement = this.chartHeader.nativeElement;
      //to pause     
      if (this.isLiveData) {
        //this.timelineDataOriginal = this.data;
        this.isLiveData = false;
        this.svgPercentageWidth = 84;
        //this is to handle - if all dps are nona only and the chart is in live state
        //then, chart doesnt maintain chache as nonArchivedTimelineData is undefined
        if (this.nonArchivedTimelineData == undefined) {
          this.nonArchivedTimelineData = new TimelineData();
          this.nonArchivedTimelineData.Data = [];
        }
        if (this.nonArchivedTimelineData.Data.length <= 0) {
          try {
            for (var serCount = 0, _count = 0; serCount < this.data.Data.length; serCount++) {
              if (this.data[serCount].Data[0].IsNonArchived) {
                this.nonArchivedTimelineData.Data[_count] = new TimelineSeries();
                this.nonArchivedTimelineData.Data[_count].DataPointName = this.data[serCount].Data[0].DataPointName;
                this.nonArchivedTimelineData.Data[_count].IsNonArchived = this.data[serCount].Data[0].IsNonArchived;
                this.nonArchivedTimelineData.Data[_count].Series = [new Series()];
                this.nonArchivedTimelineData.Data[_count].Series = this.data[serCount].Data[0].Series.slice(0, this.data[serCount].Data[0].Series.length);
                this.nonArchivedTimelineData.Data[_count].TrendSeriesId = this.data[serCount].Data[0].TrendSeriesId;
                this.nonArchivedTimelineData.Data[_count].Unit = this.data[serCount].Data[0].Unit;
                this.nonArchivedTimelineData.Data[_count].Resolution = this.data[serCount].Data[0].Resolution;
                this.nonArchivedTimelineData.Data[_count].xMax = this.data[serCount].Data[0].xMax;
                this.nonArchivedTimelineData.Data[_count].xMin = this.data[serCount].Data[0].xMin;
                this.nonArchivedTimelineData.Data[_count].yMax = this.data[serCount].Data[0].yMax;
                this.nonArchivedTimelineData.Data[_count].yMin = this.data[serCount].Data[0].yMin;
                _count++;
              }
            }
          } catch (error) {
            this.logger.logError("setInterval", "Error on ngOnInit. Error:" + error);
          }
        }
        this.isItFrom = "PAUSE";
        if (this.intervalFun != -1) {
          clearInterval(this.intervalFun);
          this.intervalFun = -1;
        }
        this.Draw(this.data);
        let thisObjWidth = this.width;
        let thisObjHeight = this.height - this.BottomOffset;
        this.setRightTooltipInitialValue(thisObjWidth / 2, thisObjHeight);
        d3.select(element).selectAll('#left-lege nd-container').style("display", "");
        d3.select(element).select(".mouse-line").style("display", "");
        d3.select(headerElement).selectAll('#refreshBtn').style("opacity", "1");

        this.setYAxisUnits();
      }
      //to start
      else if (!this.startBtnDisbaled) {
        this.isInitialLoad = true;
        this.svgPercentageWidth = 100;
        this.isLiveData = true;
        let provider = this.injector.get(this.dataProvider.name) as DataProvider;
        let _to: Date
        let _from: Date;
        _to = new Date();
        let zoomInterval = new Date(this.to).getTime() - new Date(this.from).getTime();
        this.isItFrom = "START";
        //added 5000 = 5 sec to get extra data of 5 sec as _to value is too much latest and there is chance of not having data in 
        //db for latest 5 seconds and going back in for 5 sec
        _from = new Date(_to.getTime() - (zoomInterval > 5000 ? (zoomInterval) : zoomInterval));
        if (provider) {
          provider.zoom(_from, _to);
          // Added logic to disable the start button
          this.startBtnDisbaled = true;
          let headerElement = this.chartHeader.nativeElement;
          d3.select(headerElement).selectAll('#refreshBtn').style("opacity", "0.3");
          d3.select(headerElement).selectAll('#playBtn').style("opacity", "0.3");
          d3.select(headerElement).selectAll('#pauseBtn').style("opacity", "0.3");
          setTimeout(() => {
            this.startBtnDisbaled = false;
            d3.select(headerElement).selectAll('#playBtn').style("opacity", "1");
            d3.select(headerElement).selectAll('#pauseBtn').style("opacity", "1");
          }, 5500);
        }
        d3.select(headerElement).selectAll('#refreshBtn').style("opacity", "0.3");
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.enableDisableBrush();
    }
  }

  private setYAxisUnits() {
    const transService = this.translateService;

    for (let i = 0; i < this.data.length; i++) {
      const resolution: string = this.Y_Resolution[i];
      const currentLang = transService.currentLang;
      const unit: string = this.Unit[i];
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').text(function (d) {
        var text = d;
        return text.toLocaleString(currentLang, { minimumFractionDigits: resolution, maximumFractionDigits: resolution }) + " " + unit;
      });
    }

  }
  setRightTooltipInitialValue(thisObjWidth, thisObjHeight) {
    if (this.tooltipValues != undefined && !this.isLiveData) {
      this.svg.select(".mouse-line")
        .attr("d", function () {
          var d = "M" + thisObjWidth + "," + (thisObjHeight);
          d += " " + (thisObjWidth) + "," + 0;
          return d;
        });
      let bisectDate = d3.bisector(function (d) { return d["X"]; }).left;
      let timestamp: any = this.xScale.invert(thisObjWidth) as Date;
      let datum: any;
      for (let i = 0; i < this.data.length; i++) {
        if (this.sortedData[i] != undefined) {
          if (timestamp) {
            let datum: any;
            let index = bisectDate(this.sortedData[i][0], timestamp);
            let startDatum = this.sortedData[i][0][index - 1];
            let endDatum = this.sortedData[i][0][index];
            let elementDatum: any;
            if (startDatum != undefined && endDatum != undefined) {
              if (timestamp - Date.parse(startDatum.X) > Date.parse(endDatum.X) - timestamp)
                elementDatum = endDatum;
              else
                elementDatum = startDatum;
              if (datum == undefined || (datum != undefined && timestamp - Date.parse(elementDatum.X) > Date.parse(datum.X) - timestamp)) {
                datum = elementDatum;
              }
              datum = timestamp - Date.parse(startDatum.X) > Date.parse(endDatum.X) - timestamp ? endDatum : startDatum;
            }
            else if (startDatum == undefined && endDatum != undefined) {
              if (datum == undefined || (datum != undefined && timestamp - Date.parse(endDatum.X) > Date.parse(datum.X) - timestamp)) {
                datum = endDatum;
              }
            }
            else if (startDatum != undefined && endDatum == undefined) {
              if (datum == undefined || (datum != undefined && timestamp - Date.parse(startDatum.X) > Date.parse(datum.X) - timestamp)) {
                datum = startDatum;
              }
            }
            else {
              console.log("start and end datum are undefined...");
            }
            if (datum != undefined) {
              const resolution: number = this.data[i].Data[0].Resolution;
              this.tooltipValues[i].xControl.innerHTML = (this.config.xAxisLabel ? this.config.xAxisLabel : this.currentStyle.x_axis_label) + " :" + this.convertToLocaleDate(datum.X);
              this.tooltipValues[i].yControl.innerHTML = (this.config.yAxisLabel ? this.config.yAxisLabel : this.currentStyle.y_axis_label) + " :" + this.convertToLocaleNumber(datum.Y, resolution) + " " + this.data[i].Data[0].Unit;
            }
          }
        }
      }
    }
    this.setYAxisUnits();
  }
  private startBtnDisbaled = false;
  private refreshBtnDisbaled = false;
  public refreshButtonClicked(event) {
    if (!this.refreshBtnDisbaled) {
      if (this.data == undefined) {
        d3.event.sourceEvent.stopPropagation();
      }
      if (!this.isLiveData) {
        this.isInitialLoad = true;
        let provider = this.injector.get(this.dataProvider.name) as DataProvider;
        let _to: Date = new Date();
        let _from: Date;
        _to = new Date();
        let zoomInterval = new Date(this.to).getTime() - new Date(this.from).getTime();
        this.isItFrom = "REF";
        //this is to handle - if all dps are nona only and the chart is in live state
        //then, chart doesnt maintain chache as nonArchivedTimelineData is undefined
        if (this.nonArchivedTimelineData == undefined || this.nonArchivedTimelineData.Data.length <= 0) {
          this.nonArchivedTimelineData = new TimelineData();
          this.nonArchivedTimelineData.Data = [];
        }
        if (this.nonArchivedTimelineData.Data.length <= 0) {
          try {
            for (var serCount = 0, _count = 0; serCount < this.data.Data.length; serCount++) {
              if (this.data[serCount].Data[0].IsNonArchived) {
                this.nonArchivedTimelineData.Data[_count] = new TimelineSeries();
                this.nonArchivedTimelineData.Data[_count].DataPointName = this.data[serCount].Data[0].DataPointName;
                this.nonArchivedTimelineData.Data[_count].IsNonArchived = this.data[serCount].Data[0].IsNonArchived;
                this.nonArchivedTimelineData.Data[_count].Series = [new Series()];
                this.nonArchivedTimelineData.Data[_count].Series = this.data[serCount].Data[0].Series.slice(0, this.data[serCount].Data[0].Series.length);
                this.nonArchivedTimelineData.Data[_count].TrendSeriesId = this.data[serCount].Data[0].TrendSeriesId;
                this.nonArchivedTimelineData.Data[_count].Unit = this.data[serCount].Data[0].Unit;
                this.nonArchivedTimelineData.Data[_count].Resolution = this.data[serCount].Data[0].Resolution;
                this.nonArchivedTimelineData.Data[_count].xMax = this.data[serCount].Data[0].xMax;
                this.nonArchivedTimelineData.Data[_count].xMin = this.data[serCount].Data[0].xMin;
                this.nonArchivedTimelineData.Data[_count].yMax = this.data[serCount].Data[0].yMax;
                this.nonArchivedTimelineData.Data[_count].yMin = this.data[serCount].Data[0].yMin;
                _count++;
              }
            }
          } catch (error) {
            this.logger.logError("setInterval", "Error on ngOnInit. Error:" + error);
          }
        }

        //added 5000 = 5 sec to get extra data of 2 sec as _to value is too much latest and there is chance of not having data in 
        //db for latest 5 seconds and going back in for 2 sec
        _from = new Date(_to.getTime() - (zoomInterval > 5000 ? (zoomInterval) : zoomInterval));
        if (provider) {
          provider.zoom(_from, _to);
        }
      }
      this.refreshBtnDisbaled = true;
      let headerElement = this.chartHeader.nativeElement;
      d3.select(headerElement).selectAll('#refreshBtn').style("opacity", "0.3");
      setTimeout(() => {
        this.refreshBtnDisbaled = false;
        if (!this.isLiveData)
          d3.select(headerElement).selectAll('#refreshBtn').style("opacity", "1");
      }, 5500);
    }
  }
  private redrawMainChart() {
    try {
      if (this.hasDummyData.length > 0) {
        this.data.forEach((value, index) => {
          this.mainChart.selectAll("#TREND_" + (index + 1)).style('stroke-width', 1.5);
        });
      }
      if (this.xAxisScaleToMaintain != undefined)
        this.xScale.domain([this.xAxisScaleToMaintain[0], this.xAxisScaleToMaintain[1]]).range([0, this.width]);
      else
        this.xScale.domain([this.X_Min, this.X_Max]).range([0, this.width]);
      this.mainXAxisGroup.call(this.xAxis);


      this.chart.select(".x.axis").selectAll('.tick').selectAll('line').style('stroke', this.currentStyle.x_axis_color).style('stroke-width', this.x_Oppacity);
      this.chart.select(".y.axis").selectAll('.tick').selectAll('line').style('stroke', this.currentStyle.y_axis_color).style('stroke-width', this.x_Oppacity);
      this.chart.select(".x.axis").selectAll('.tick').selectAll('text')
        .style('fill', this.currentStyle.x_axis_color).style('font-size', this.currentStyle.x_axis_font_size).attr('font-size', this.currentStyle.x_axis_font_size)
        .style('fill', this.currentStyle.x_axis_color).style('font-family', this.currentStyle.x_axis_font).attr('font-family', this.currentStyle.x_axis_font);
      this.chart.select(".y.axis").selectAll('.tick').selectAll('text')
        .style('fill', this.currentStyle.y_axis_color).style('font-size', this.currentStyle.y_axis_font_size)
        .style('fill', this.currentStyle.x_axis_color).style('font-family', this.currentStyle.y_axis_font).attr('font-family', this.currentStyle.y_axis_font);

      var localeNumeric: any;
      var isValidJson = this.IsValidJsonString(JSON.stringify(this.localeFormat));
      if (isValidJson) {
        var localeJSON = JSON.parse(JSON.stringify(this.localeFormat));
        isValidJson = localeJSON.ChartLocale && localeJSON.NumericLocale && this.IsValidNumberCulture(localeJSON.NumericLocale);
      }


      for (let i = 0; i < this.data.length; i++) {
        // if (isValidJson) {
        //   localeNumeric = d3.formatLocale(localeJSON.NumericLocale);
        //   let resolutionFormat: string = "." + this.Y_Resolution[i] + "f";          
        //   this.yAxis[i].tickFormat(localeNumeric.format("," + resolutionFormat));

        //}

        //this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('stroke', this.getColor(i)).style('stroke-width', 1);
        this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('fill', this.getColor(i));
        this.chart.select("#Y" + i).selectAll('.tick').selectAll('line').style('stroke', this.getColor(i)).style('stroke-width', 1);

      }

      //this.yScale[i].domain([this.Y_Min[i], this.Y_Max[i]]).range([(this.height - this.BottomOffset - 0), 5]).nice();
      // this.mainYAxisGroup[i].call(this.yAxis[i]);       

      //   this.mainLinePath[i]
      //     .attr('class', 'line')
      //     .attr("class", "TRENDSERIES")
      //     .attr('id', (d, k) => { return "TREND_" + (i + 1) })
      //     .style('stroke', (d, k) => { return this.getColor(i) })
      //     .attr("stroke-width", "1.5px")
      //     .attr('d', (d, k) => { return this.plotLine[i](d.Series) });

      //   this.chart.select("#Y" + i).select('.domain').style('stroke', this.getColor(i)).style('stroke-width', 1);
      //   this.chart.select("#Y" + i).selectAll('.tick').selectAll('line').style('stroke', this.getColor(i)).style('stroke-width', 1);
      //   this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('fill', this.getColor(i));
      //   this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('font-size', (this.currentStyle.y_axis_font_size + "px"));
      //   this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('font-family', this.currentStyle.y_axis_font);
      //   this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').attr('font-family', this.currentStyle.y_axis_font);

      //   const resolution =this.Y_Resolution[i] ;       
      //   const unit = this.Unit[i];
      //   const currentLang = this.translateService.currentLang;
      //   console.log("RedrawMain called");

      //   this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').text(function (d) {
      //     var text = d;      
      //     return text.toLocaleString(currentLang, { minimumFractionDigits: resolution, maximumFractionDigits: resolution }) + " " + unit;
      //   });

      //}

    } catch (error) {
      this.logger.logError("TrendSeriesChart: redrawMainChart", "error while redrawing line series chart. Error: " + error);
    }
    finally {
      this.logger.logInfo("TrendSeriesChart: redrawMainChart", "completed");
    }
  }
  private redrawNavChart() {
    try {
      //update nav chart
      if (this.xAxisScaleToMaintain != undefined)
        this.navXScale.domain([this.xAxisScaleToMaintain[0], this.xAxisScaleToMaintain[1]]).range([0, this.width]);
      else
        this.navXScale.domain([this.X_Min, this.X_Max]).range([0, this.width]);
      for (let i = 0; i < this.data.length; i++) {
        this.navYScale.domain([this.Y_Min[i], this.Y_Max[i]]);
      }

      this.navXAxisGroup
        .attr("class", "brush")
        .call(this.brush)
        .call(this.brush.move, this.navXScale.range());

      this.navXAxisGroup.select("#brush-label-start").attr("fill", "black");
      this.navXAxisGroup.select("#brush-label-end").attr("fill", "black");
      this.navXAxisGroup.select(".handle.handle--e").remove();
      this.navXAxisGroup.select(".handle.handle--w").remove();
      this.setNavChartTooltip();
    } catch (error) {
      this.logger.logError("TrendSeriesChart: redrawNavChart", "error while redrawing line series chart. Error: " + error);
    }

  }
  Update(newData: any) {
    //add data to missed data on pause

  }
  private setDataBoundries() {
    //calculate min max values     
    this.X_Max = d3.max(this.data, function (d) { return d3.max(d["Data"][0].Series, function (d) { return d["X"]; }); });
    this.X_Min = d3.min(this.data, function (d) { return d3.min(d["Data"][0].Series, function (d) { return d["X"]; }); });
    for (let i = 0; i < this.data.length; i++) {
      let ymax: any = d3.max(this.data[i].Data[0].Series, function (d) { return d["Y"]; })
      let ymin: any = d3.min(this.data[i].Data[0].Series, function (d) { return d["Y"]; })
      if (ymax == ymin && ymax !== undefined && ymin !== undefined) {
        this.Y_Max[i] = ymax + 10;
        this.Y_Min[i] = ymin - 10;
      }
      else if (ymax !== undefined && ymin !== undefined) {
        this.Y_Max[i] = ymax;
        this.Y_Min[i] = ymin;
      }
      var valMin = parseFloat(this.Y_Min[i]);
      this.Y_Min[i] = Math.floor(valMin / 10) * 10;
      var j = parseFloat(this.Y_Max[i]);
      var roundToPositive = j > 50 ? 50 : j > 100 ? 100 : j > 1000 ? 1000 : 1;
      this.Y_Max[i] = Math.ceil(j / roundToPositive) * roundToPositive;

      this.data[i].Data[0].xMax = this.X_Max;
      this.data[i].Data[0].xMin = this.X_Min;
      this.data[i].Data[0].yMin = this.Y_Min[i];
      this.data[i].Data[0].yMax = this.Y_Max[i];
    }
    if (this.xAxisScaleToMaintain.length == 2) {
      this.from = this.xAxisScaleToMaintain[0];
      this.to = this.xAxisScaleToMaintain[1];
    }
    else {
      this.from = this.X_Min;
      this.to = this.X_Max;
    }
  }

  ZoomChart() {
    // get current mouse position    
    var mouseclickFromDate: Date = null;
    var mouseclickToDate: Date = null;
    var factor: number = (Math.abs(this.wheelDelta) / 120);
    // max factor shoud be 3
    factor = factor < 4 ? factor : 3;
    let oldStartDate = this.last_x_min;
    let oldEndDate = this.last_x_max;
    if (this.wheelDelta > 0) {
      let rangeStart = this.X_Min;
      let rangeTo = this.X_Max;

      let diff = this.X_Min === undefined && this.X_Max === undefined ? 3600000 : Math.abs(this.X_Max.getTime() - this.X_Min.getTime());

      let clickDate = this.xScale.invert(this.mousePosX) as Date;
      let dayNumber = (diff / 100) * this.multiplierForZoom / factor;
      let NumDate: number = clickDate.getTime();
      let frmDate = new Date(NumDate - dayNumber);
      let toDate = new Date(NumDate + dayNumber);

      mouseclickFromDate = frmDate;
      mouseclickToDate = toDate;
      this.last_x_min = mouseclickFromDate;
      this.last_x_max = mouseclickToDate;

      if (this.X_Min !== undefined && mouseclickFromDate < rangeStart)
        mouseclickFromDate = rangeStart;

      if (this.X_Max !== undefined && mouseclickToDate > rangeTo)
        mouseclickToDate = rangeTo;

      let areAllNonArchived = true;
      for (let tCount = 0; tCount < this.data.length; tCount++) {
        if (!this.data[tCount].Data[0].IsNonArchived) {
          areAllNonArchived = false;
          break;
        }
      }
      //handle zoom in for all non archived data
      //we need to set from date to oldest date for COV's
      if (areAllNonArchived) {
        let fromD: any = d3.min(this.data, function (d) { return d3.min(d["Data"][0].Series, function (d) { return d["X"]; }); });
        if (fromD === undefined) { fromD = new Date(mouseclickToDate.getTime() - 5 * 60 * 1000); }
        //if from date and to date difference is less than 5 mins, then make this at least 5 min difference
        if ((mouseclickToDate.getTime() - fromD.getTime()) < 5 * 60 * 1000) {
          fromD = new Date(mouseclickToDate.getTime() - 5 * 60 * 1000);
          mouseclickFromDate = fromD;

          this.last_x_min = fromD;
          this.last_x_max = mouseclickToDate;
        }
      }
    }
    //zoom out
    else if (this.wheelDelta < 0) {
      let diff = Math.abs(this.last_x_max.getTime() - this.last_x_min.getTime());
      let dayNumber = Math.ceil(diff / (1000 * 3600 * 24));

      let days = (dayNumber / 100) * this.multiplierForZoom * factor;

      mouseclickToDate = this.last_x_max = new Date(this.last_x_max.getTime() + days * 24 * 60 * 60 * 1000);
      mouseclickFromDate = this.last_x_min = new Date(this.last_x_min.getTime() - days * 24 * 60 * 60 * 1000);

      //adding extra 10 minutes for zoom out as latest live data was not showing on zoom out on right side
      //for combination of NONA and Archived trends
      mouseclickToDate.setMinutes(mouseclickToDate.getMinutes() + 10);

    }

    // reset the wheeldelta
    this.wheelDelta = -1;

    if (mouseclickFromDate && mouseclickToDate) {

      var fromdate = mouseclickFromDate.toString();
      var todate = mouseclickToDate.toString();

      // zoom only when zoom range is grater than 5 min
      if (this.isValidZoomRange(false, fromdate, todate) && !this.zooming) {

        //to set maximum to date to current date. it should no t show the dates from future
        if (mouseclickToDate > new Date()) {
          todate = new Date().toString();
        }
        // zoom the range     

        let provider = (this.injector.get(this.dataProvider.name)) as DataProvider;
        if (provider) {
          // added to avoid multiple zooms
          this.zooming = true;
          this.isItFrom = "ZOOM";
          this.logger.logInfo("TrendSeriesMultiAxisChart", "zooming is blocked now.");
          // hide the trends on zoom
          let trends = this.chart.selectAll('.TRENDSERIES');
          if (trends)
            trends.style("stroke-width", 0.00001);
          provider.zoom(fromdate, todate);

          // remove the legends
          if (this.mainChart.selectAll(".legendSectionMain")) {
            var legendG = this.mainChart.selectAll(".legendSectionMain");
            legendG.remove();
          }
        }
      } else {
        this.last_x_max = oldEndDate;
        this.last_x_min = oldStartDate;
      }
    }
  }

  getTimelineData(data: any) {
    let dataCollection = new TimelineDataCollection;
    dataCollection.TimelineData = [];
    let timelineData: TimelineData = new TimelineData;
    timelineData.Data = [];

    data.Data.forEach(element => {
      if (element.Series.length != 0) {
        let seriesCollection: TimelineSeries = new TimelineSeries;
        seriesCollection.Series = [];
        element.Series.forEach(function (d) {
          d.Y = new Number(d.Y);
          d.X = new Date(d.X)
        });
        seriesCollection.xMin = d3.min(element.Series, (d: Series, index: number, arr: any) => d.X);
        seriesCollection.xMax = d3.max(element.Series, (d: Series, index: number, arr: any) => d.X);
        seriesCollection.yMin = d3.min(element.Series, (d: Series, index: number, arr: any) => d.Y);
        seriesCollection.yMax = d3.max(element.Series, (d: Series, index: number, arr: any) => d.Y);
        if (seriesCollection.yMax == seriesCollection.yMin) {
          seriesCollection.yMax = seriesCollection.yMax + 10;
          seriesCollection.yMin = seriesCollection.yMin - 10;
        }
        var i = parseFloat(seriesCollection.yMin);
        // var roundToNegative = j < -50 ? 50 : j < -100 ? 100 : j < -1000 ? 1000 : 10;
        // seriesCollection.yMin = Math.floor(i / roundToNegative) * roundToNegative;
        seriesCollection.yMin = Math.floor(i / 10) * 10;


        var j = parseFloat(seriesCollection.yMax);
        var roundToPositive = j > 50 ? 50 : j > 100 ? 100 : j > 1000 ? 1000 : 1;
        seriesCollection.yMax = Math.ceil(j / roundToPositive) * roundToPositive;

        seriesCollection.Series = element.Series;
        seriesCollection.DataPointName = element.DataPointName;
        seriesCollection.TrendSeriesId = element.TrendSeriesId;
        seriesCollection.IsNonArchived = element.IsNonArchived;
        seriesCollection.Unit = element.Unit;
        seriesCollection.Resolution = element.Resolution;
        timelineData.Data.push(seriesCollection);
      }
      else if (element.Series.length == 0) {
        let seriesCollection: TimelineSeries = new TimelineSeries;
        seriesCollection.Series = [];
        seriesCollection.yMin = 0;
        seriesCollection.yMax = 10;
        seriesCollection.xMin = element.xMin;
        seriesCollection.xMax = element.xMax;
        seriesCollection.Series = element.Series;
        seriesCollection.DataPointName = element.DataPointName;
        seriesCollection.TrendSeriesId = element.TrendSeriesId;
        seriesCollection.IsNonArchived = element.IsNonArchived;
        seriesCollection.Unit = element.Unit;
        seriesCollection.Resolution = element.Resolution;
        timelineData.Data.push(seriesCollection);
      }
    });
    if (this.config && this.config.mergeAxis) {
      var arr = timelineData.Data.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.yMin.toString() === thing.yMin.toString() && t.yMax.toString() === thing.yMax.toString()
        ))
      )
      arr.forEach(x => {
        let newTimeLine: TimelineData = new TimelineData;
        newTimeLine.Data = [];
        timelineData.Data.forEach((series) => {
          if (x.yMin.toString() == series.yMin.toString() && x.yMax.toString() == series.yMax.toString()) {
            newTimeLine.Data.push(series);
          }
        });
        dataCollection.TimelineData.push(newTimeLine);
      })
    } else {
      timelineData.Data.forEach((series) => {
        let newTimeLine: TimelineData = new TimelineData;
        newTimeLine.Data = [];
        newTimeLine.Data.push(series);
        dataCollection.TimelineData.push(newTimeLine);
      });
    }
    return dataCollection.TimelineData;
  }
  getConfig() { return this.dataProvider.privateConfig; }
  createChart() {
    this.maxValueForYAxisLength = 0;
    try {
      let element = this.chartContainer.nativeElement;
      if (typeof this.data === 'undefined' || this.data === null) {
        // Defect 1066402: Trends when zoomed in to a no data period would make the chart disappear and show only an error message.
        // To fix this defect not showing thr error message in case of zoom
        if (!this.zooming) {
          this.drawErrorChart(this.ERROR_TEXT);
        } else {
          this.zooming = false;
        }
        return;
      }

      this.chartContainer.nativeElement.innerHTML = '';
      let xmin: any = [], xmax: any = [], ymin: any = [], ymax: any = [];
      this.xIsDateTime = true;
      let i = 0;
      this.sortedData = []
      this.data.forEach(series => {
        this.sortedData[i] = [];
        this.sortedData[i][0] = this.data[i].Data[0].Series;
        xmin[i] = d3.min(this.data, function (d) { return d["Data"][0]["xMin"] });
        xmax[i] = d3.max(this.data, function (d) { return d["Data"][0]["xMax"] });
        if (this.zooming || this.isInitialLoad) {
          this.Y_Min[i] = new Number(this.data[i].Data[0].yMin);
          this.Y_Max[i] = new Number(this.data[i].Data[0].yMax);
        }
        i++;
      });

      if (this.zooming || this.isInitialLoad) {
        this.X_Max = new Date(d3.max(xmax));
        this.X_Min = new Date(d3.min(xmin));
        //this is to handle zoom out where left side it shows the blank as we dont have data for any of the trend till that right xAxisScale 
        if (this.isItFrom == "ZOOM" && this.xAxisScaleToMaintain.length == 2 && this.X_Max < this.xAxisScaleToMaintain[1]) {
          this.xAxisScaleToMaintain[1] = this.X_Max;
          this.isItFrom = "LOAD";
        }

        if (this.xAxisScaleToMaintain.length == 2) {
          this.from = this.xAxisScaleToMaintain[0];
          this.to = this.xAxisScaleToMaintain[1];
        }
        else {
          this.from = this.X_Min;
          this.to = this.X_Max;
        }
      }
      if (!this.widgetDrawn && this.xAxisScaleToMaintain.length == 2) {
        this.last_x_min = this.xAxisScaleToMaintain[0];
        this.last_x_max = this.xAxisScaleToMaintain[1];
        this.widgetDrawn = true;
      }
      else if (!this.widgetDrawn) {
        this.last_x_min = this.X_Min;
        this.last_x_max = this.X_Max;
        this.widgetDrawn = true;
      }
      //draw legend and title 
      this.drawSupportComponent();
      //Changed by Anuradha
      //this.BottomOffset = this.height / 3;
      this.BottomOffset = 60;
      if (this.currentStyle.y_axis_label_visible)
        this.drawYAxisLabel();


      for (let i = 0; i < this.Y_Max.length; i++) {
        this.yLabelMaxValues[i] = this.getYAxisMaxLabelWidth(this.Y_Max[i], this.Y_Min[i], this.Y_Resolution[i], this.Unit[i]);
        this.maxValueForYAxisLength = this.maxValueForYAxisLength + this.yLabelMaxValues[i];
        this.width = this.width - (this.yLabelMaxValues[i]);
      }

      this.prepareChartArea();

      //draw x and y axis lines
      this.drawAxisAndLine(this.X_Min, this.X_Max, this.Y_Min, this.Y_Max);

      this.getXAxisMaxWidth();

      if (this.currentStyle.x_axis_label_visible)
        this.drawXAxisLabel();

      this.drawNavigationChart(this.X_Min, this.X_Max, d3.min(this.Y_Min), d3.max(this.Y_Max));
      if (!this.isLiveData) {
        this.createLeftTooltip();
      }
      this.setRightTooltipInitialValue(this.width / 2, this.height - this.BottomOffset);
      // free the zoom after 800ms
      setTimeout(() => {
        this.zooming = false;
      }, 800);
      this.logger.logInfo("TrendSeriesMultiAxisChart", "free to zoom.");
    }
    catch (error) {
      this.logger.logError("TrendSeriesMultiAxisChart", "Error while drawing TrendSeries chart. Error:" + error);
    }
  }
  getYAxisMaxLabelWidth(maxY: any, minY: any, resolution: number, unit: string) {

    var dummyTitle1 = this.mainChart.append("text")
      .attr('class', 'dummytitle1')
      .attr("font-size", this.currentStyle.y_axis_font_size)
      .style("font-size", (this.currentStyle.y_axis_font_size + "px"))
      .attr("font-family", this.currentStyle.y_axis_font)
      .text(maxY.toFixed(resolution) + " " + unit);

    var dummyTitle2 = this.mainChart.append("text")
      .attr('class', 'dummytitle2')
      .attr("font-size", this.currentStyle.y_axis_font_size)
      .style("font-size", (this.currentStyle.y_axis_font_size + "px"))
      .attr("font-family", this.currentStyle.y_axis_font)
      .text(minY.toFixed(resolution) + " " + unit);

    let width1 = (dummyTitle1.node().getBBox().width);
    let width2 = (dummyTitle2.node().getBBox().width);
    let padding = 42;
    let maxWidth = width1 > width2 ? width1 + padding : width2 + padding;

    this.mainChart.selectAll('.dummytitle1').remove();
    this.mainChart.selectAll('.dummytitle2').remove();

    return maxWidth;
  }
  drawSupportComponent() {
    let element = this.chartContainer.nativeElement;

    this.svg = d3.select(element).append('svg')
      .attr('width', (element.offsetWidth * this.svgPercentageWidth / 100))
      .attr('height', element.offsetHeight)
      .style('background-color', this.currentStyle.background_color);

    this.tooltipGroup = d3.select(element).append('div');
    this.width = element.offsetWidth * this.svgPercentageWidth / 100 - (this.currentStyle.margin.right + this.currentStyle.margin.left * (this.isLiveData ? 1 : 1));//3.5));
    this.height = element.offsetHeight - (this.currentStyle.margin.bottom + this.currentStyle.margin.top);
    this.leftLegendWidth = element.offsetWidth * (100 - this.svgPercentageWidth) / 100;
    this.leftLegendHeight = this.height;

    this.mainChart = this.svg.append('g')
      .attr('class', "main-group")
      .attr('width', this.width + (this.isLiveData ? 0 : this.currentStyle.margin.left * 1))//2.5))
      .attr('height', this.height)
      .attr('transform', 'translate(' + this.currentStyle.margin.left + ',' + this.currentStyle.margin.top + ')');

    if (this.currentStyle.legend_visible) {
      this.drawLegends();
    }
  }

  private prepareChartArea() {
    var translate = this.getTranslateForMainChart();
    this.chart = this.mainChart.append('g')
      .attr('class', 'd3-chart1')
      .attr('width', this.width)
      .attr('height', this.height - this.BottomOffset)
      .attr('transform', translate);

    this.chart.append("rect")
      .attr("id", "zoom" + this.id)
      .attr("class", "zoom")
      .attr("width", this.width)
      .attr("height", this.height - this.BottomOffset);

    // this.plotArea = this.chart.append('g')
    //   .attr('clip-path', 'url(#plotAreaClip)');

    // this.plotArea.append('clipPath')
    //   .attr('id', 'plotAreaClip')
    //   .append('rect')
    //   .attr('width', this.width)
    //   .attr('height', this.height - this.BottomOffset).attr('overflow', 'hidden');
  }

  getTranslateForMainChart(): string {
    let x = (this.yLabelHeight * 2) + (this.maxValueForYAxisLength);
    let y = 1;

    if (this.currentStyle.title_position == "top")
      y = y + this.titleHeight;

    if (this.currentStyle.legend_position == "top")
      y = y + this.legendHeightoffset + this.legendAdjustmentFactor;

    let translate = "translate(" + (x) + "," + (y) + ")"

    return translate;
  }

  getXAxisMaxWidth() {
    var dummyTitle = this.mainChart.append("text")
      .attr('class', 'dummytitle')
      .attr("font-size", this.currentStyle.x_axis_font_size)
      .style("font-size", this.currentStyle.x_axis_font_size)
      .attr("font-family", this.currentStyle.x_axis_font)
      .text(this.X_Max);

    var dummytitle = this.mainChart.selectAll('.dummytitle');

    this.maxValueForXAxisHeight = dummytitle.node().getBBox().height;

    this.mainChart.selectAll('.dummytitle').remove();
  }


  drawLegends() {
    try {
      var legenddata: any = [];
      var tempIndex = 1;
      for (let i = 0; i < this.data.length; i++) {
        //   var tempcolor = d3.scaleLinear().domain([0, 9]).range(<any[]>[this.colors[i], "#1A237E"]);
        //  var trendColors = d3.scaleLinear().domain([0, this.data[i].Data.length - 1]).range(<any[]>[this.colors[i], tempcolor(9)]);
        for (let j = 0; j < this.data[i].Data.length; j++) {
          legenddata.push(
            {
              "key": this.data[i].Data[j].DataPointName,
              "value": undefined,
              "color": this.getColor(i),
              "id": 'Legend_' + tempIndex
            });
          tempIndex++;
        }
      }

      var legendStyle = {
        "font-size": this.currentStyle.legend_font_size,
        "fill": this.currentStyle.legend_font_color,
        "font-family": this.currentStyle.legend_font
      }

      var widgetDimension = {
        "height": this.height,
        "width": this.width
      }

      let legendPosition = this.currentStyle.legend_position;

      if (this.mainChart.selectAll(".legendSectionMain"))
        this.mainChart.selectAll(".legendSectionMain").remove()


      let legend = this.mainChart.append('g')
        .attr("class", "legendSectionMain");

      var rowsinserted = this.widgetHelper.getDivisionForLegend(legendPosition, legendStyle, legenddata, legend, widgetDimension);

      for (let k = 0; k < legenddata.length; k++) {
        this.mainChart.select('#' + legenddata[k].id).on("click", () => {
          var box = legend.select('#' + legenddata[k].id);
          var isHidden = JSON.parse(box.attr("isHidden"));
          var imageElement = box.select('.imageShowHide');
          var id = legenddata[k].id.split('_')[1];
          var trends = this.mainChart.selectAll('#TREND_' + id);
          var yAxis = this.mainChart.selectAll('#Y' + (id - 1));
          var unit = this.mainChart.selectAll('#unit' + (id - 1));
          if (isHidden) {
            box.style("fill-opacity", 1);
            box.attr("isHidden", false);
            imageElement.attr("xlink:href", "assets/hideEye.png");
            if (this.hasDummyData.length === 0 || (this.hasDummyData.length > 0 && this.hasDummyData.findIndex(x => x == id) == -1)) {
              trends.style("stroke-width", 1.5)
            }
            yAxis.style("opacity", 1);
            unit.style("opacity", 1);
            if (!this.isLiveData) {
              let nodes = this.leftLegend.nodes();
              //nodes[k].style["opacity"] = 1;  
              nodes[k].style["display"] = "";
            }
          } else {
            box.style("fill-opacity", 0.25);
            box.attr("isHidden", true);
            imageElement.attr("xlink:href", "assets/showEye.png")
            trends.style("stroke-width", 0.00001);
            yAxis.style("opacity", 0.4);
            unit.style("opacity", 0.4);
            if (!this.isLiveData) {
              let nodes = this.leftLegend.nodes();
              //nodes[k].style["opacity"] = 0.3;     
              nodes[k].style["display"] = "none";
            }
          }
        })
      }
      this.legendHeightoffset = d3.max(this.mainChart.selectAll(".templegend").nodes(), (d: any) => {
        return d.getBBox().height as number
      });

      let translate: string;
      if (legendPosition == "top") {
        var yfactor = this.currentStyle.title_position == "top" ? this.titleHeight + this.legendAdjustmentFactor : 1;
        translate = "translate(" + (1) + "," + (yfactor) + ")"
      }
      else if (legendPosition === "bottom") {
        var yfactor = this.currentStyle.title_position == "bottom" ?
          (this.height - this.legendHeightoffset + this.legendAdjustmentFactor) :
          (this.height - this.legendHeightoffset + this.legendAdjustmentFactor);
        translate = "translate(" + (1) + "," + (yfactor) + ")"
      }

      legend.attr("transform", translate);
      this.height = this.height - (this.legendHeightoffset + this.legendAdjustmentFactor);
    }
    catch (error) {
      this.logger.logError("TrendSeriesMultiAxisChart", "Error while drawing the legends. Error:" + error);
    }
  }


  drawXAxisLabel() {
    try {
      this.chart.append('text')
        .attr('class', 'x_axis_label')

        .attr('text-anchor', 'middle')
        .style('font-size', this.currentStyle.x_axis_font_size)
        .attr('font-size', this.currentStyle.x_axis_font_size)
        .style('fill', this.currentStyle.x_axis_color)
        .attr("font-family", this.currentStyle.x_axis_font)
        .text(this.config.xAxisLabel ? this.config.xAxisLabel : this.currentStyle.x_axis_label);

      let xlabel = (this.mainChart.selectAll(".x_axis_label"))
      this.xAxisLabelHeight = xlabel ? xlabel.node().getBBox().height : 1;
      var yValue = (this.height - this.BottomOffset + this.maxValueForXAxisHeight + this.xAxisLabelHeight)

      xlabel.attr('transform', 'translate(' + this.width / 2 + ',' + yValue + ')')

    }
    catch (error) {
      this.logger.logError("TrendSeriesMultiAxisChart", "Error while drawing X axis label. Error:" + error);
    }
  }

  drawYAxisLabel() {
    try {
      this.mainChart.append('text')
        .attr('class', 'y_axis_label')
        .attr('text-anchor', 'middle')
        .style('font-size', (this.currentStyle.y_axis_font_size + "px"))
        .attr('font-size', this.currentStyle.y_axis_font_size)
        .style('fill', this.currentStyle.y_axis_color)
        .attr("font-family", this.currentStyle.y_axis_font)
        .text(this.config.yAxisLabel ? this.config.yAxisLabel : this.currentStyle.y_axis_label);

      let ylabel = (this.mainChart.selectAll(".y_axis_label"))
      this.yLabelHeight = ylabel ? ylabel.node().getBBox().height : 1;

      ylabel.attr('transform', 'translate(' + this.yLabelHeight + ',' + ((this.height - this.BottomOffset) / 2) + ')rotate(-90)')

      this.width = this.width - (this.yLabelHeight);

    }
    catch (error) {
      this.logger.logError("TrendSeriesMultiAxisChart", "Error while drawing Y axis label. Error:" + error);
    }
  }

  drawNavigationChart(Xmin: any, Xmax: any, Ymin: any, Ymax: any) {

    //let navHeight = (this.height / 3) - this.maxValueForXAxisHeight;
    let navHeight = 50;

    if (this.currentStyle.x_axis_label_visible)
      navHeight = navHeight - this.xAxisLabelHeight

    if (this.currentStyle.legend_visible)
      navHeight = navHeight - 20;

    let myY = this.getYForNavChart();

    this.navXAxisGroup = this.chart.append('g')
      .classed('navigator', true)
      .attr('width', this.width)
      .attr('height', navHeight)
      .attr('transform', 'translate(' + 0 + ',' + (myY + 10) + ')');
    if (this.xAxisScaleToMaintain != undefined) {
      this.navXScale = this.xIsDateTime ? d3.scaleTime()
        .domain([this.xAxisScaleToMaintain[0], this.xAxisScaleToMaintain[1]])
        .range([0, this.width]) : d3.scaleLinear()
          .domain([this.xAxisScaleToMaintain[0], this.xAxisScaleToMaintain[1]])
          .range([0, this.width]);

    }
    else {
      this.navXScale = this.xIsDateTime ? d3.scaleTime()
        .domain([Xmin, Xmax])
        .range([0, this.width]) : d3.scaleLinear()
          .domain([Xmin, Xmax])
          .range([0, this.width]);
    }


    this.navYScale = this.yIsDateTime ? d3.scaleTime()
      .domain([Ymin, Ymax])
      .range([navHeight, 0]) : d3.scaleLinear()
        .domain([Ymin, Ymax])
        .range([navHeight, 0]);

    this.navXAxis = d3.axisBottom(this.navXScale);
    let x = (d: any) => { return this.navXScale(d.X) }
    let y = (d: any) => { return this.navYScale(d.Y); }
    let navLine = d3.line()
      .x(x)
      .y(y);

    var tempIndex = 1;
    for (let i = 0; i < this.data.length; i++) {

      // var tempcolor = d3.scaleLinear().domain([0, 9]).range(<any[]>[this.colors[i], "#1A237E"]);
      // var trendColors = d3.scaleLinear().domain([0, this.data[i].Data.length - 1]).range(<any[]>[this.colors[i], tempcolor(9)]);

      for (let j = 0; j < this.data[i].Data.length; j++) {
        this.navXAxisGroup.append('path')
          .data([this.data[i].Data[j].Series])
          // .attr('class', 'line')
          .attr('id', (d) => {
            return "TREND_" + tempIndex
          })
        // .style('stroke', (d) => { return trendColors(j) })
        // .attr('d', (d) => { return navLine(d) });
        tempIndex++;
      }
    }

    this.brush = d3.brushX()
      .extent([[0, 0], [this.width, 15]])
      .on("brush end", () => {
        if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") return; // ignore brush-by-zoom
        let s = d3.event.selection || this.navXScale.range();
        this.xScale.domain(s.map(this.navXScale.invert, this.navXScale));

        this.setAxis(this.height);
        this.chart.select(".zoom").call(zoom.transform, d3.zoomIdentity
          .scale(this.width / (s[1] - s[0]))
          .translate(-s[0], 0))
        if (s && (Number(s[1]) - Number(s[0]) >= 300)) {
          this.setNaigationLabel(this.navXAxisGroup, s, 1);
        }
        else {
          this.setNaigationLabel(this.navXAxisGroup, s, 0);
        }
        this.setNavChartTooltip();
        this.setRightTooltipInitialValue(this.width / 2, this.height - this.BottomOffset);
      });

    var zoomend = () => {
      if (!this.isLiveData) {
        if (d3.event && d3.event.type == "end" && !d3.event.sourceEvent) {
          this.logger.logInfo("TrendSeriesMultiAxisChart", "zooming in the given range.");
          // zoom the chart.     
          this.ZoomChart();
        }
        this.setYAxisUnits();
      }
    }

    var zoom = d3.zoom()
      .scaleExtent([-1000, 1000])
      .translateExtent([[0, 0], [this.width, this.height]])
      .extent([[0, 0], [this.width, this.height]])
      .on("zoom", () => {
        if (!this.isLiveData) {
          if (d3.event.sourceEvent && d3.event.sourceEvent.type === "brush") return; // ignore zoom-by-brush

          if (d3.event.sourceEvent && d3.event.sourceEvent.type === "wheel") {

            let wheelevent: WheelEvent = d3.event.sourceEvent;
            let eventTarget = d3.event.sourceEvent.target;
            let dimentions = eventTarget.getBoundingClientRect();
            if (/*Math.abs(wheelevent.wheelDelta) >= 120 ||*/ Math.abs(wheelevent.deltaY) >= 65) {
              // if (this.wheelDelta < Math.abs(wheelevent.wheelDelta))
              //   this.wheelDelta = wheelevent.wheelDelta;
               if (this.wheelDelta < Math.abs(wheelevent.deltaY))
                this.wheelDelta = wheelevent.deltaY * -1;

              this.mousePosX = d3.event.sourceEvent.clientX - dimentions.left;
              // console.log("mouse wheel position:"+this.mousePosX.toString());

              if (Number(this.mousePosX) <= 0)
                this.mousePosX = 1;
            }
          }
          else {
            this.navXAxisGroup.select(".brush").call(this.brush.move, this.xScale.range().map(d3.event.transform.invertX, d3.event.transform));
          }
        }
      }).on("end", zoomend);

    this.navXAxisGroup.append("g")
      .attr("class", "brush")
      .call(this.brush)
      .call(this.brush.move, this.navXScale.range());

    for (let i = 0; i < this.data.length; i++) {
      const resolution: string = this.Y_Resolution[i];
      const transService = this.translateService;
      const currentLang = transService.currentLang;

      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').attr('font-size', this.currentStyle.y_axis_font_size).text(function (d) {
        var text = d;
        return Number(text).toLocaleString(currentLang, { maximumFractionDigits: Number(resolution), minimumFractionDigits: Number(resolution) });//this.convertToLocaleNumber(Number(text),Number(resolution));//.toFixed(resolution);
      });

    }

    this.setToolTip();

    if (this.isLiveData) {
      this.chart.select('#zoom' + this.id).call(zoom);
      this.navXAxisGroup.select(".handle.handle--e").remove()
      this.navXAxisGroup.select(".handle.handle--w").remove();
    }
    else {
      this.createTooltip();
      this.chart.select(".zoom")
        .call(zoom);
      this.setTooltipEvents();
    }
  }
  createTooltip() {
    let thisObjIsAlive = this.isLiveData;
    let thisObjHeight = this.height - this.BottomOffset
      , thisObjWidth = this.width;
    //Tooltips
    this.lineFocus = this.chart.append("g")
      .attr("class", "line-focus vertical-line-tooltip-container")
      .style("display", "none");
    this.lineRect = this.lineFocus.append("rect")
      .attr("class", "line-focus-inner vertical-line-tooltip")
      .attr("rx", 2)
      .attr("ry", 2)
      .attr("x", 9)
      .attr("dy", ".35em")
      .style("stroke", "Gray")
      .style("stroke-width", "0.5")
      .style("opacity", "1")
      .style("fill", this.currentStyle.tooltip_background);
    // //Adds text to focus point on line 
    this.lineTooltiptextelement = this.lineFocus.append("text")
      .attr("x", 9)
      .attr("dy", ".35em")
      .style("font-size", this.currentStyle.tooltip_font_size)
      .attr("font-size", this.currentStyle.tooltip_font_size)
      .style("font-family", this.currentStyle.tooltip_font)
      .style("fill", this.currentStyle.tooltip_font_color);
    this.lineTooltiptextelement.append("tspan").attr("id", "value").attr("x", 15).attr("dy", "1.2em");
    this.lineTooltiptextelement.append("tspan").attr("id", "name").attr("x", 15).attr("dy", "1.2em");
    this.lineTooltiptextelement.append("tspan").attr("id", "timestamp").attr("x", 15).attr("dy", "1.2em");
    var mouseG = this.plotArea.append("g")
      .attr("class", "mouse-over-effects")
      .attr("transform", "translate(" + (0) + "," + (0) + ")");
    // this is the black vertical line to follow mouse
    mouseG.append("path")
      .attr("class", "mouse-line")
      .attr("draggable", "true")
      .style("stroke", "black")
      .style("cursor", "ew-resize")
      .style("stroke-width", "2.0px")
      .style("opacity", "1")
      .style("display", () => {
        if (thisObjIsAlive) {
          return "none"
        }
        else return ""
      })
      .attr("d", function () {
        var d = "M" + thisObjWidth / 2 + "," + (thisObjHeight);
        d += " " + (thisObjWidth / 2) + "," + 0;
        return d;
      });
  }
  setTooltipEvents() {
    let thisObj = this;
    let drag = d3.drag()
      .on('start', function (d) {
        thisObj.isDragStrated = true;
        thisObj.lineFocus.style("display", null);
        d3.event.sourceEvent.stopPropagation();
      })
      .on('drag', function (d) {
        var mouseLine = d3.mouse(this as SVGSVGElement);
        if (thisObj.isLiveData) {
          thisObj.svg.select(".mouse-line").style("display", "none");
        }
        else {
          thisObj.setLegendValues(thisObj, this, true);
        }
      })
      .on('end', function (d) {
        thisObj.isDragStrated = false;
        //d3.select(this).classed('active', false);
        thisObj.lineFocus.style("display", "none");
        if (!thisObj.isLiveData) {
          if (thisObj.mouseLineScale != -1 && thisObj.mouseLineScale < 0) {
            thisObj.svg.select(".mouse-line").style("display", "")
              .attr("d", function () {
                var d = "M" + 2 + "," + (thisObj.height - thisObj.BottomOffset);//thisObj.height;
                d += " " + 2 + "," + 0;
                return d;
              });
            thisObj.mouseLineScale = -1;
          }
          else if (thisObj.mouseLineScale != -1 && Math.round(thisObj.mouseLineScale) > Math.round(thisObj.width)) {
            thisObj.svg.select(".mouse-line").style("display", "")
              .attr("d", function () {
                var d = "M" + (thisObj.width - 2) + "," + (thisObj.height - thisObj.BottomOffset);//thisObj.height;
                d += " " + (thisObj.width - 2) + "," + 0;
                return d;
              });
            //console.log("Small Scale1: " + (thisObj.width - 2));
            thisObj.mouseLineScale = -1;
          }
        }
      });
    this.plotArea.selectAll('.mouse-line')
      .call(drag);
  }
  setLegendValues(thisObj, parentControl, isFromLine) {
    let bisectDate;
    bisectDate = d3.bisector(function (d) { return d["X"]; }).left;
    let datum: any;
    let duumyDatum: any;
    let timestamp: any = thisObj.xScale.invert(d3.mouse(thisObj.plotArea.node())[0]) as Date;
    try {
      var mouseLine = d3.mouse(parentControl as SVGSVGElement);
      for (let i = 0; i < thisObj.data.length; i++) {
        try {
          if (thisObj.sortedData[i] != undefined) {
            if (!isFromLine && d3.event.sourceEvent) return; // ignore zoom-by-brush
            //var trends = thisObj.chart.selectAll('.TRENDSERIES');          
            if (timestamp) {
              let index = bisectDate(thisObj.sortedData[i][0], timestamp);
              let startDatum = thisObj.sortedData[i][0][index - 1];
              let endDatum = thisObj.sortedData[i][0][index];
              let elementDatum: any;
              //for two items from series start and end datum
              if (startDatum != undefined && endDatum != undefined) {
                if (timestamp - Date.parse(startDatum.X) > Date.parse(endDatum.X) - timestamp)
                  elementDatum = endDatum;
                else
                  elementDatum = startDatum;
                if (duumyDatum == undefined || (duumyDatum != undefined && timestamp - Date.parse(elementDatum.X) > Date.parse(duumyDatum.X) - timestamp)) {
                  duumyDatum = elementDatum;
                }
                duumyDatum = timestamp - Date.parse(startDatum.X) > Date.parse(endDatum.X) - timestamp ? endDatum : startDatum;
              }
              //if start datum is undefined, and we have only end datum
              // means we dont have point before mpuse
              else if (startDatum == undefined && endDatum != undefined) {
                if (duumyDatum == undefined || (duumyDatum != undefined && timestamp - Date.parse(endDatum.X) > Date.parse(duumyDatum.X) - timestamp)) {
                  duumyDatum = endDatum;
                }
              }
              //if end datum is undefined, and we have only start datum
              // means we dont have point after mpuse
              else if (startDatum != undefined && endDatum == undefined) {
                if (duumyDatum == undefined || (duumyDatum != undefined && timestamp - Date.parse(startDatum.X) > Date.parse(duumyDatum.X) - timestamp)) {
                  duumyDatum = startDatum;
                }
              }
              else {
                console.log("start and end datum are undefined...");
              }
              //we found data point in series and hence updating to UI right tool tip
              if (duumyDatum != undefined && isFromLine) {
                const resolution: number = this.data[i].Data[0].Resolution;
                thisObj.tooltipValues[i].xControl.innerHTML = (this.config.xAxisLabel ? this.config.xAxisLabel : this.currentStyle.x_axis_label) + " :" + this.convertToLocaleDate(duumyDatum.X);
                thisObj.tooltipValues[i].yControl.innerHTML = (this.config.yAxisLabel ? this.config.yAxisLabel : this.currentStyle.y_axis_label) + " :" + this.convertToLocaleNumber(duumyDatum.Y, resolution) + " " + this.data[i].Data[0].Unit;
              }
              if (duumyDatum != undefined)
                datum = duumyDatum;
              duumyDatum = undefined;
            }
          }
        } catch (error) {
          if (isFromLine) {
            thisObj.tooltipValues[i].xControl.innerHTML = (this.config.xAxisLabel ? this.config.xAxisLabel : this.currentStyle.x_axis_label) + " :";
            thisObj.tooltipValues[i].yControl.innerHTML = (this.config.yAxisLabel ? this.config.yAxisLabel : this.currentStyle.y_axis_label) + " :";
            console.error(error);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
    try {
      let d = datum;
      if (datum != undefined) {
        thisObj.lineFocus.select("#timestamp").text((thisObj.config && thisObj.config.xAxisLabel ? thisObj.config.xAxisLabel : thisObj.currentStyle.x_axis_label) + " : " + this.convertToLocaleDate(d.X));
        let bb = thisObj.lineTooltiptextelement.node().getBBox();
        if (bb && bb.height && bb.width) {
          thisObj.lineRect.attr("height", bb.height + 10).attr("width", bb.width + 10);
        }
        var scaleX = thisObj.xScale(d.X);
        thisObj.lineFocus.style("display", "initial");
        let position = 0, tooltipPosition = 0;
        //if mouse is in plot area, then draw line at mouse present
        if (Math.round(mouseLine[0]) >= 0 && Math.round(mouseLine[0]) <= Math.round(thisObj.width)) {
          position = mouseLine[0];
          if ((Math.round(mouseLine[0]) == 0) || (Math.round(mouseLine[0]) == Math.round(thisObj.width))) {
            position = (Math.round(scaleX) == Math.round(thisObj.width) ? (mouseLine[0] - 2) : (mouseLine[0] + 2));
          }
          //in second half
          if ((position + bb.width) > thisObj.width) {
            tooltipPosition = position - (bb.width + 20);
          }
          //first half
          else {
            tooltipPosition = position - 7;
          }
          thisObj.mouseLineScale = -1;
        }
        //if mouse is out of plot area
        else {
          thisObj.mouseLineScale = mouseLine[0];
          //if mouse is in left of plot area
          if (mouseLine[0] < 0) {
            position = 2;
            tooltipPosition = position;
            thisObj.mouseLineScale = -1;
          }
          //if mouse is to the right of the plot area
          else if (Math.round(mouseLine[0]) > Math.round(thisObj.width)) {
            position = thisObj.width - 2;
            tooltipPosition = position - (bb.width + 20);
            thisObj.mouseLineScale = -1;
          }
          else {
            thisObj.mouseLineScale = scaleX;
          }
        }

        //if we have postion, then draw the line and line tooltip
        if (thisObj.mouseLineScale == -1) {
          thisObj.svg.select(".mouse-line").style("display", "")
            .attr("d", function () {
              var d = "M" + (position) + "," + (thisObj.height - thisObj.BottomOffset);//thisObj.height;
              d += " " + (position) + "," + 0;
              return d;
            });
          thisObj.lineFocus.attr("transform", "translate(" + (tooltipPosition) + "," + mouseLine[1] + ")");
        }
      }
      else {
        console.log("datum is undefined");
      }
    } catch (error) {
      console.error(error);
    }
  }
  createLeftTooltip() {
    //let element = this.chartContainer.nativeElement;
    this.tooltipGroup
      .attr('id', 'left-legend-container')
      .attr("class", "tooltipContainer left-legend-container")
      .style('max-height', this.leftLegendHeight + 10 + 'px')
      .style('max-width', this.leftLegendWidth + 'px')
      .style('min-width', this.leftLegendWidth + 'px')
      .style('fill', 'white');
    for (let i = 0; i < this.data.length; i++) {
      let value: TooltipValue = new TooltipValue();
      if (typeof this.tooltipValues == 'undefined') {
        this.tooltipValues = [value];
      }
      else {
        this.tooltipValues.push(value);
      }
    }
    let lCount = 0;
    let legend = this.tooltipGroup
      .selectAll('.left-legend')
      .data(this.data)
    let _lcount = 0;

    this.leftLegend = legend
      .enter()
      .append('div')
      .style('margin-bottom', '5px')
      .attr('class', (d) => {
        let a = (d.Data[0].DataPointName).replace(new RegExp(" ", 'g'), "");
        return 'left-legend' + (d.Data[0].DataPointName).replace(new RegExp(" ", 'g'), "") + ' visible ' + (d.Data[0].DataPointName).replace(new RegExp(" ", 'g'), "");
      })
      .attr('id', (d) => { return d.Data[0].DataPointName.replace(new RegExp(" ", 'g'), ""); })
      .style('cursor', "pointer");
    lCount = 0;
    let legendCount = 0;
    let legendCircleP = 0;
    this.leftLegend.append('div')
      .attr('class', (d) => { legendCount++; return 'left-legend-circle lineCircle' + (legendCount - 1) })
      .style("background-color", (d) => {
        _lcount++;
        return this.getColor(_lcount - 1)
      });

    legendCount = 0;
    legendCircleP = 0;
    lCount = 0;
    //add the legend text
    this.leftLegend.append('text')
      .style("font-family", this.currentStyle.legend_font)
      .style("font-size", this.currentStyle.legend_font_size)
      .style("color", this.currentStyle.legend_font_color)
      .attr("class", "left-legend-text")
      .text(function (d) { return d.Data[0].DataPointName; });
    legendCount = 0;
    legendCircleP = 0;
    let _count = 0;
    lCount = 0;
    let xseries = this.leftLegend.append("text")
      .attr("transform", (d) => { return "translate(" + (this.width + 10) + "," + (+5) + ")" })
      .attr("class", (d) => { legendCount++; return 'series-value-x series-value-x-' + (legendCount - 1) })
      .attr("id", (d) => { return "x-" + (d.Data[0].DataPointName).replace(new RegExp(" ", 'g'), "") })
      .style('display', 'block')
      .text((this.config.xAxisLabel ? this.config.xAxisLabel : this.currentStyle.x_axis_label) + " :" + "")
      .style("font-size", this.currentStyle.legend_font_size)
      .style("color", this.currentStyle.legend_font_color)
      .style("font-family", this.currentStyle.legend_font);
    lCount = 0;
    let ysereis = this.leftLegend.append("text")
      .attr("transform", (d) => { return "translate(" + (this.width + 10) + "," + ((25)) + ")" })
      .attr("class", (d) => { legendCount++; return 'series-value-y series-value-y-' + (legendCount - 1) })
      .attr("id", (d) => { return "y-" + (d.Data[0].DataPointName).replace(new RegExp(" ", 'g'), "") })
      .style('display', 'block')
      .text((this.config.yAxisLabel ? this.config.yAxisLabel : this.currentStyle.y_axis_label) + " :" + "")
      .style("font-size", this.currentStyle.legend_font_size)
      .style("color", this.currentStyle.legend_font_color)
      .style("font-family", this.currentStyle.legend_font);
    let itemCount = 0;
    this.tooltipValues.forEach(tooltipElement => {
      let tooltip: TooltipValue = new TooltipValue();
      tooltip.xControl = xseries.nodes()[itemCount];
      tooltip.yControl = ysereis.nodes()[itemCount];
      this.tooltipValues[itemCount] = tooltip;
      itemCount++;
    });
  }

  getYForNavChart() {
    // let navHeight = (this.height / 3) - (this.maxValueForXAxisHeight);
    let navHeight = 50;
    let y = (this.height - navHeight);

    if (this.currentStyle.x_axis_label_visible)
      y = y + this.maxValueForXAxisHeight + 10;

    if (this.currentStyle.legend_font_size == "top")
      y = y + this.legendAdjustmentFactor;

    return y;
  }
  convertToLocaleDate(dateToConvert: Date): any {
    let currentLang = this.translateService.currentLang;
    var isValidJson = this.IsValidJsonString(JSON.stringify(this.localeFormat));
    if (isValidJson) {
      var localeJSON = JSON.parse(JSON.stringify(this.localeFormat));
      isValidJson = localeJSON.ChartLocale && localeJSON.NumericLocale && this.IsValidDateCulture(localeJSON.ChartLocale)
        && this.IsValidNumberCulture(localeJSON.NumericLocale);
      if (isValidJson) {
        let options2 = JSON.parse(JSON.stringify(this.localeFormat));
        return dateToConvert.toLocaleString(currentLang, options2);
      }
      return dateToConvert;
    }
    return dateToConvert;
  }

  convertToLocaleNumber(num: number, resolution: number): string {
    //  let num = Number(numString);
    let currentLang = this.translateService.currentLang;
    return num.toLocaleString(currentLang, { maximumFractionDigits: resolution, minimumFractionDigits: resolution });
  }

  IsValidJsonString(str) {
    try {
      JSON.parse(str);
    } catch (err) {
      this.logger.logError("TrendSeriesChart", "error while parsing locale json. Error: " + err);
      return false;
    }
    return true;
  }

  IsValidDateCulture(obj: any) {
    try {
      d3.timeFormatLocale(obj)
    } catch (err) {
      this.logger.logError("IsValidDateCulture", "error timeFormatLocale locale json. Error: " + err);
      return false;
    }
    return true;
  }

  IsValidNumberCulture(obj: any) {
    try {
      d3.formatLocale(obj);
    } catch (err) {
      this.logger.logError("IsValidNumberCulture", "error in formatLocale locale json. Error: " + err);
      return false;
    }
    return true;
  }

  private drawAxisAndLine(Xmin: any, Xmax: any, Ymin: any, Ymax: any) {
    var tickFormat = function (date) {
      if (date.getMinutes()) return d3.timeFormat('%H:%M:%S')(date);
      if (date.getHours()) return d3.timeFormat('%H:%M:%S')(date);
      if (date.getDay() && date.getDate() != 1) return d3.timeFormat('%d-%b-%y')(date);
      if (date.getDate() != 1) return d3.timeFormat('%d-%b-%y')(date);
      if (date.getMonth()) return d3.timeFormat('%d-%b-%y')(date);
      return d3.timeFormat('%Y')(date);
    }

    var localeNumeric: any;
    var isValidJson = this.IsValidJsonString(JSON.stringify(this.localeFormat));
    if (isValidJson) {
      var localeJSON = JSON.parse(JSON.stringify(this.localeFormat));
      isValidJson = localeJSON.ChartLocale && localeJSON.NumericLocale && this.IsValidDateCulture(localeJSON.ChartLocale)
        && this.IsValidNumberCulture(localeJSON.NumericLocale);

      if (isValidJson) {
        var locale = d3.timeFormatLocale(localeJSON.ChartLocale);
        localeNumeric = d3.formatLocale(localeJSON.NumericLocale);

        var formatMillisecond = locale.format(".%L"),
          formatSecond = locale.format(localeJSON.ChartLocale.time),
          formatMinute = locale.format(localeJSON.ChartLocale.time),
          formatHour = locale.format(localeJSON.ChartLocale.time),
          formatDay = locale.format(localeJSON.ChartLocale.date),
          formatWeek = locale.format(localeJSON.ChartLocale.date),
          formatMonth = locale.format(localeJSON.ChartLocale.date),
          formatYear = locale.format("%Y");

        tickFormat = function (date) {
          return (d3.timeSecond(date) < date ? formatMillisecond
            : d3.timeMinute(date) < date ? formatSecond
              : d3.timeHour(date) < date ? formatMinute
                : d3.timeDay(date) < date ? formatHour
                  : d3.timeMonth(date) < date ? (d3.timeWeek(date) < date ? formatDay : formatWeek)
                    : d3.timeYear(date) < date ? formatMonth
                      : formatYear)(date);
        }
      }
    }

    if (this.xAxisScaleToMaintain != undefined)
      this.xScale = this.xIsDateTime ? d3.scaleTime().domain([this.xAxisScaleToMaintain[0], this.xAxisScaleToMaintain[1]]).range([0, this.width]) : d3.scaleLinear().domain([this.xAxisScaleToMaintain[0], this.xAxisScaleToMaintain[1]]).range([0, this.width]);
    else
      this.xScale = this.xIsDateTime ? d3.scaleTime().domain([Xmin, Xmax]).range([0, this.width]) : d3.scaleLinear().domain([Xmin, Xmax]).range([0, this.width]);
    this.xAxis = d3.axisBottom(this.xScale).tickSizeInner(-this.height + this.BottomOffset).tickSizeOuter(0).tickFormat(tickFormat);
    let numberOfTicks = Math.round(this.width / 100);
    this.xAxis.ticks(numberOfTicks);
    //this.chart.append('g').attr('class', 'x axis').attr('transform', 'translate(' + 0 + ',' + (this.height - this.BottomOffset) + ')').call(this.xAxis);
    this.mainXAxisGroup = this.chart.append('g').attr('class', 'x axis').attr('transform', 'translate(' + 0 + ',' + (this.height - this.BottomOffset) + ')');
    this.mainXAxisGroup.call(this.xAxis);
    this.chart.select('.x.axis').select('.domain').style('stroke', this.currentStyle.x_axis_color).style('stroke-width', this.x_Oppacity);
    this.chart.select('.x.axis').selectAll('.tick').selectAll('line').style('stroke', this.currentStyle.x_axis_color).style('stroke-width', this.x_Oppacity);
    this.chart.select('.x.axis').selectAll('.tick').selectAll('text').style('fill', this.currentStyle.x_axis_color);
    this.chart.select('.x.axis').selectAll('.tick').selectAll('text').attr('dy', "0.95em");
    this.plotArea = this.chart.append('g')
      .attr('clip-path', 'url(#plotMultiAreaClip' + this.GUID + ')');

    this.plotArea.append('clipPath')
      .attr('id', 'plotMultiAreaClip' + this.GUID)
      .append('rect')
      .attr('width', this.width)
      .attr('height', this.height - this.BottomOffset).attr('overflow', 'hidden');

    let thisObj = this;
    this.plotArea.on("mouseout", function (d) {
      if (thisObj.isDragStrated) {
        let mouse = d3.mouse(this as SVGSVGElement);
        if (mouse[0] > thisObj.width) {
          thisObj.setRightTooltipInitialValue(thisObj.width - 2, thisObj.height - thisObj.BottomOffset);
        }
        else if (mouse[0] < 0) {
          thisObj.setRightTooltipInitialValue(2, thisObj.height - thisObj.BottomOffset);
        }
      }
    });

    var yMargin = 0;
    var tempIndex = 1;
    for (let i = 0; i < this.data.length; i++) {
      this.plotLine[i] = d3.line().x((d: any) => {
        return this.xScale(d.X);
      })
        .y((d: any) => {
          return this.yScale[i](d.Y);
        });
      let resolutionFormat: string = "." + this.Y_Resolution[i] + "f";
      var tickFormatY = function (value) {
        const unit = this.Units[i];
        return d3.format(resolutionFormat)(value) + " :" + unit;
      };
      this.yScale[i] = this.yIsDateTime ? d3.scaleTime().domain([this.Y_Min[i], this.Y_Max[i]]).range([((this.height - 0) - this.BottomOffset), 5]).nice() : d3.scaleLinear().domain([this.Y_Min[i], this.Y_Max[i]]).range([((this.height - 0) - this.BottomOffset), 5]).nice();

      if (isValidJson) {
        this.yAxis[i] = d3.axisLeft(this.yScale[i]).tickFormat(localeNumeric.format("," + resolutionFormat));
      }
      else {
        this.yAxis[i] = d3.axisLeft(this.yScale[i]).tickFormat(tickFormatY);
      }

      this.mainYAxisGroup[i] = this.chart.append('g').attr('id', "Y" + i).attr('class', 'y axis').attr('transform', 'translate(' + yMargin + ',0)');//.call(this.yAxis);
      //this.mainYAxisGroup[i].push(this.chart.append('g').attr('id', "Y" + i).attr('class', 'y axis').attr('transform', 'translate(' + yMargin + ',0)').call(this.yAxis));
      this.mainYAxisGroup[i].call(this.yAxis[i]);

      this.chart.select("#Y" + i).select('.domain').style('stroke', this.getColor(i)).style('stroke-width', 1);
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('line').style('stroke', this.getColor(i)).style('stroke-width', 1);
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('fill', this.getColor(i));
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('font-size', (this.currentStyle.y_axis_font_size + "px"));
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').attr('font-family', this.currentStyle.y_axis_font);

      let group = this.plotArea.append('g').attr('class', 'series');
      for (let j = 0; j < this.data[i].Data.length; j++) {

        let path = group.append("path")
          .data(this.data[i].Data)
          .attr("fill", "None")
          .attr("class", "TRENDSERIES")
          .attr('id', (d) => {
            return "TREND_" + tempIndex
          })
          .style('stroke', this.getColor(i))
          .attr("stroke-width", "1.5px")
          .attr("d", (d) => { return this.plotLine[i](d.Series) });

        this.mainLinePath.push(path);
        tempIndex++;
      }
      yMargin = yMargin - this.yLabelMaxValues[i];
    }
    this.hasDummyData.forEach(seriesIndex =>{
      this.mainChart.selectAll("#TREND_" + seriesIndex).style('stroke-width', 0);
    });
  }

  private getMinY(data: any) {
    return data.reduce((min, p) => p.P < min ? p.Y : min, data[0].Y);
  }
  private getMaxY(data: any) {
    return data.reduce((max, p) => p.Y > max ? p.Y : max, data[0].Y);
  }

  setAxis(navHeight: any) {
    if (this.sortedData === undefined)
      return;
    let startX = this.xScale.domain();

    for (let i = 0; i < this.sortedData.length; i++) {
      for (let j = 0; j < this.sortedData[i].length; j++) {
        if (this.sortedData[i] !== undefined && this.sortedData[i][j] !== undefined && this.sortedData[i][j].length > 0) {

          let YMin_temp: number;
          let YMax_temp: number;

          let MinIndex = this.bisectValueMin(this.sortedData[i][j], startX[0], 0, this.sortedData[i][j].length - 1);
          let MaxIndex = this.bisectValueMax(this.sortedData[i][j], startX[1], 0, this.sortedData[i][j].length - 1);
          if (MinIndex === MaxIndex) {
            MinIndex = MinIndex - 1;
            if (MinIndex < 0) {
              MinIndex = 0;
            }
            MaxIndex = MaxIndex + 1
            if (MaxIndex >= this.sortedData[i][j].length) {
              MaxIndex = this.sortedData[i][j].length - 1;
            }
          }
          YMin_temp = this.sortedData[i][j][MinIndex].Y;
          YMax_temp = this.sortedData[i][j][MaxIndex].Y;

          let arr = this.sortedData[i][j].filter(
            m => {
              if (new Date(m.X) >= new Date(startX[0]) && new Date(m.X) <= new Date(startX[1])) {
                // console.log(m);
                return m;
              }
            });

          if (arr.length > 0) {
            YMin_temp = this.getMinY(arr);
            YMax_temp = this.getMaxY(arr);
          }

          this.Y_Min[i] = YMin_temp;
          this.Y_Max[i] = YMax_temp;

          for (let k = MinIndex; k <= MaxIndex; k++) {
            if (this.sortedData[i][j][k].Y < YMin_temp) {
              YMin_temp = this.sortedData[i][j][k].Y;
              if (YMin_temp < this.Y_Min[i])
                this.Y_Min[i] = YMin_temp;
            }
            if (this.sortedData[i][j][k].Y > YMax_temp) {
              YMax_temp = this.sortedData[i][j][k].Y;
              if (YMax_temp > this.Y_Max[i])
                this.Y_Max[i] = YMax_temp;
            }
          }
        }
      }
    }


    var tempIndex = 1;
    for (let i = 0; i < this.data.length; i++) {
      if (this.Y_Min[i].valueOf() === this.Y_Max[i].valueOf()) {
        this.yScale[i].domain([this.Y_Min[i] - 1, this.Y_Max[i] + 1]).nice();
      }
      else {
        this.yScale[i].domain([this.Y_Min[i], this.Y_Max[i]]).nice();
      }
      this.yAxis[i] = d3.axisLeft(this.yScale[i]);

      this.chart.select(".x.axis").call(this.xAxis).selectAll('.tick').selectAll('line').style('stroke', this.currentStyle.x_axis_color).style('stroke-width', this.x_Oppacity);

      this.chart.select("#Y" + i).call(this.yAxis[i]).selectAll('.tick').selectAll('line').style('stroke', this.currentStyle.y_axis_color).style('stroke-width', this.x_Oppacity);

      this.chart.select(".x.axis").selectAll('.tick').selectAll('text').style('fill', this.currentStyle.x_axis_color);
      this.chart.select(".x.axis").selectAll('.tick').selectAll('text').style('font-size', this.currentStyle.x_axis_font_size);
      this.chart.select(".x.axis").selectAll('.tick').selectAll('text').attr('font-size', this.currentStyle.x_axis_font_size);
      this.chart.select(".x.axis").selectAll('.tick').selectAll('text').style('font-family', this.currentStyle.x_axis_font);
      this.chart.select(".x.axis").selectAll('.tick').selectAll('text').attr('font-family', this.currentStyle.x_axis_font);

      const resolution: string = this.Y_Resolution[i];
      const transService = this.translateService;
      const currentLang = transService.currentLang;

      const unit: string = this.Unit[i];
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('font-size', (this.currentStyle.y_axis_font_size + "px"));
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').attr('font-family', this.currentStyle.y_axis_font);
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('line').style('stroke', this.getColor(i)).style('stroke-width', 1);
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').style('fill', this.getColor(i));
      this.chart.select("#Y" + i).selectAll('.tick').selectAll('text').attr('font-size', this.currentStyle.y_axis_font_size).text(function (d) {
        var text = d;
        return text.toLocaleString(currentLang, { minimumFractionDigits: resolution, maximumFractionDigits: resolution }) + " " + unit;
      });
      for (let j = 0; j < this.data[i].Data.length; j++) {
        this.chart.select('#TREND_' + tempIndex).attr('d', this.plotLine[i](this.data[i].Data[j].Series));
        tempIndex++;
      }

    }
  }

  setNavChartTooltip() {
    this.navXAxisGroup.select(".navfocus").remove();
    this.navFocus = this.navXAxisGroup.append("g")
      .attr("class", "navfocus")
      .style("display", "none");
    let rect = this.navFocus.append("rect")
      .attr("class", "rect-navfocus")
      .attr("rx", 2)
      .attr("ry", 2)
      .attr("x", 9)
      .attr("dy", ".35em")
      .style("stroke", "Gray")
      .style("stroke-width", "0.5")
      .style("opacity", "1")
      .style("fill", this.currentStyle.tooltip_background);
    // //Adds text to focus point on line 
    let tooltipText = this.navFocus.append("text")
      .attr("x", 15)
      .attr("dy", "1.2em")
      .style("font-size", this.currentStyle.tooltip_font_size)
      .attr("font-size", this.currentStyle.tooltip_font_size)
      .style("font-family", this.currentStyle.tooltip_font)
      .style("fill", this.currentStyle.tooltip_font_color);
    tooltipText.append("tspan").attr("id", "value").attr("x", 15).attr("dy", "1.2em");
    let dateDiff = this.navEndLabel.getTime() - this.navStartLabel.getTime();
    let tooltipTextValue = "";
    let second = 1000;
    let minute = second * 60;
    let hour = minute * 60;
    let day = hour * 24;

    let navchart = this.navXAxisGroup.select('.selection');
    this.navXAxisGroup.select('.selection').on("mousemove", () => {
      var translate = d3.mouse(navchart.node());
      if (dateDiff > day) {
        tooltipTextValue = this.convertToLocaleNumber((dateDiff / day), 2) + " " + this.DAYS;
      } else if (dateDiff > hour) {
        tooltipTextValue = this.convertToLocaleNumber((dateDiff / hour), 2) + " " + this.HOURS;
      } else if (dateDiff > minute) {
        tooltipTextValue = this.convertToLocaleNumber((dateDiff / minute), 2) + " " + this.MINUTES;
      } else if (dateDiff > second) {
        tooltipTextValue = this.convertToLocaleNumber((dateDiff / second), 2) + " " + this.SECONDS;
      } else {
        tooltipTextValue = this.convertToLocaleNumber((dateDiff), 2) + " " + this.MILLISECONDS;
      }
      tooltipText.text(tooltipTextValue);
      let bb = tooltipText.node().getBBox();
      if (bb && bb.height && bb.width) {
        rect.attr("height", bb.height + 10).attr("width", bb.width + 10);
      }
      this.navFocus.attr("transform", "translate(" + (translate[0] - bb.width - 20) + "," + (translate[1]) + ")");
      this.navFocus.style("display", "initial");
    }).on("mouseout", () => {
      if (this.navFocus)
        this.navFocus.transition().style("display", "none");
    });
  }
  setToolTip() {

    let tooltipextent = this.plotArea.select('rect').node().getBBox();
    const bisectDate = d3.bisector((d: any) => { return d.X; }).right;

    //Tooltips
    this.focus = this.chart.append("g")
      .attr("class", "focus")
      .style("display", "none");

    let rect = this.focus.append("rect")
      .attr("class", "rect-focus")
      .attr("rx", 2)
      .attr("ry", 2)
      .attr("x", 9)
      .attr("dy", ".35em")
      .style("stroke", "Gray")
      .style("stroke-width", "0.5")
      .style("opacity", "1")
      .style("fill", this.currentStyle.tooltip_background);

    //Adds circle to focus point on line
    this.circle = this.chart.append("g").attr("class", "focus")
      .append("circle")
      .style("display", "none")
      .attr("r", 4)
      .on("mouseover", () => {
        if (this.focus)
          this.focus.style("display", null);
        this.chart.select("circle").style("display", null)
      })
      .on("mousemove", (mousemove) => {
        if (this.focus)
          this.focus.style("display", null);
        this.chart.select("circle").style("display", null)

      })
      .on("mouseout", () => {
        if (this.focus) {
          this.chart.select("circle").transition().style("display", "none");
          this.focus.transition().style("display", "none");
          var source = d3.event.currentTarget.id;
          var trends = this.chart.selectAll('.TRENDSERIES');
          trends.nodes().forEach(element => {
            if (element.id != source) {
              var strokeWidth = parseFloat(element.style["stroke-width"]);
              if (strokeWidth != 0.00001) { this.chart.selectAll('#' + element.id).style("stroke-width", 1.5); }
            }
          });
        }
      });

    // //Adds text to focus point on line 
    this.tooltiptextelement = this.focus.append("text")
      .attr("x", 9)
      .attr("dy", ".35em")
      .style("font-size", this.currentStyle.tooltip_font_size)
      .attr("font-size", this.currentStyle.tooltip_font_size)
      .style("font-family", this.currentStyle.tooltip_font)
      .style("fill", this.currentStyle.tooltip_font_color);

    this.tooltiptextelement.append("tspan").attr("id", "value").attr("x", 15).attr("dy", "1.2em");
    this.tooltiptextelement.append("tspan").attr("id", "name").attr("x", 15).attr("dy", "1.2em");
    this.tooltiptextelement.append("tspan").attr("id", "timestamp").attr("x", 15).attr("dy", "1.2em");
    var tempIndex = 1;
    for (let i = 0; i < this.data.length; i++) {
      //var tempcolor = d3.scaleLinear().domain([0, 9]).range(<any[]>[this.colors[i], "#1A237E"]);
      for (let j = 0; j < this.data[i].Data.length; j++) {
        this.chart.select('#TREND_' + tempIndex)
          .on("mouseover", () => {
            if (this.focus)
              this.focus.style("display", null);
            this.chart.select("circle").style("display", null)
          })
          .on("mouseout", () => {
            if (this.focus) {
              this.chart.select("circle").transition().style("display", "none");
              this.focus.transition().style("display", "none");
              var source = d3.event.currentTarget.id;
              var trends = this.chart.selectAll('.TRENDSERIES');
              trends.nodes().forEach(element => {
                if (element.id != source) {
                  var strokeWidth = parseFloat(element.style["stroke-width"]);
                  if (strokeWidth != 0.00001) { this.chart.selectAll('#' + element.id).style("stroke-width", 1.5); }
                }
              });
            }
          })
          .on("mouseover", (mousemove) => {
            {
              if (d3.event.sourceEvent) return; // ignore zoom-by-brush
              // var trendColors = d3.scaleLinear().domain([0, this.data[i].Data.length - 1]).range(<any[]>[this.colors[i], tempcolor(9)]);
              let timestamp: any = this.xScale.invert(d3.mouse(this.plotArea.node())[0]) as Date;
              var source = d3.event.currentTarget.id;
              var trends = this.chart.selectAll('.TRENDSERIES');
              trends.nodes().forEach(element => {
                if (element.id != source) {
                  var strokeWidth = parseFloat(element.style["stroke-width"]);
                  if (strokeWidth != 0.00001) { this.chart.selectAll('#' + element.id).style("stroke-width", 0.1); }
                } else {
                  this.chart.selectAll('#' + source).style("stroke-width", 1.5);
                }
              });
              if (timestamp) {
                let index = bisectDate(this.sortedData[i][j], timestamp);
                let startDatum = this.sortedData[i][j][index - 1];
                let endDatum = this.sortedData[i][j][index];
                let d: any;
                if (endDatum != undefined && endDatum != null && startDatum != undefined && startDatum != null) {
                  d = timestamp - Date.parse(startDatum.X) > Date.parse(endDatum.X) - timestamp ? endDatum : startDatum;
                }
                else if (startDatum == undefined && endDatum != undefined) {
                  d = endDatum;
                }
                else if (startDatum != undefined && endDatum == undefined) {
                  d = startDatum;
                }
                else {
                  console.log("start and end datum are undefined...");
                }
                if (d != undefined) {
                  const resolution: number = this.data[i].Data[j].Resolution;
                  this.chart.select("circle").style("stroke", this.getColor(i))
                  this.focus.select("#name").text((this.config && this.config.pointNameLabel ? this.config.pointNameLabel : this.currentStyle.point_name_label) + " : " + this.data[i].Data[j].DataPointName);
                  this.focus.select("#value").text((this.config && (this.config.yAxisLabel ? this.config.yAxisLabel : this.currentStyle.y_axis_label)) + " : " + this.convertToLocaleNumber(d.Y, resolution) + " " + this.data[i].Data[j].Unit);
                  this.focus.select("#timestamp").text((this.config && (this.config.xAxisLabel ? this.config.xAxisLabel : this.currentStyle.x_axis_label)) + " : " + this.convertToLocaleDate(d.X));
                  let bb = this.tooltiptextelement.node().getBBox();
                  if (bb && bb.height && bb.width)
                    rect.attr("height", bb.height + 10).attr("width", bb.width + 10);
                  var scaleX = this.xScale(d.X);
                  if ((scaleX + bb.width) > this.width) {
                    this.chart.select("circle").attr("transform", "translate(" + this.xScale(d.X) + "," + this.yScale[i](d.Y) + ")");
                    this.focus.attr("transform", "translate(" + (this.xScale(d.X) - bb.width - 20) + "," + this.yScale[i](d.Y) + ")");
                    this.chart.select("circle").style("display", "initial");
                    this.focus.transition()
                      .delay(500).style("display", "initial");
                  } else {
                    this.focus.attr("transform", "translate(" + this.xScale(d.X) + "," + this.yScale[i](d.Y) + ")");
                    this.chart.select("circle").attr("transform", "translate(" + this.xScale(d.X) + "," + this.yScale[i](d.Y) + ")");
                    this.chart.select("circle").style("display", "initial");
                    this.focus.transition()
                      .delay(500).style("display", "initial");
                  }
                }
              }
            }
          });
        tempIndex++;
      }
    }
  }
  setNaigationLabel(navChart, selection, moveText) {
    /************ Move brush label ***************/
    let navBegin: number = Number(selection[0]);
    let navEnd: number = Number(selection[1]);
    this.navStartLabel = this.navXScale.invert(navBegin) as Date;
    this.navEndLabel = this.navXScale.invert(navEnd) as Date;
    let navStartDate = (this.navXScale.invert(navBegin) as Date).toDateString();
    let navEndDate = (this.navXScale.invert(navEnd) as Date).toDateString();
    let tempData: any[] = [];
    tempData.push(navStartDate);
    tempData.push(navEndDate);
    let bSelection = navChart.selectAll("text").data([tempData]);
    bSelection.enter().append("text")
      .attr("id", "brush-label-start")
      .attr("dx", "0.1em")
      .attr("dy", "0.99em")
      .attr("font-size", this.currentStyle.x_axis_font_size)
      .style("font-size", this.currentStyle.x_axis_font_size)
      .attr("font-family", this.currentStyle.x_axis_font)
      .style("fill", this.currentStyle.x_axis_color)
      .attr("fill", this.currentStyle.x_axis_color);

    bSelection.enter().append("text")
      .attr("id", "brush-label-end")
      .attr("dx", "-7.9em")
      .attr("dy", "0.99em")
      .attr("font-size", this.currentStyle.x_axis_font_size)
      .style("font-size", this.currentStyle.x_axis_font_size)
      .attr("font-family", this.currentStyle.x_axis_font)
      .style("fill", this.currentStyle.x_axis_color)
      .attr("fill", this.currentStyle.x_axis_color);

    let navStartDateLabel = this.convertToLocaleDate(this.navStartLabel);
    let navEndDateLabel = this.convertToLocaleDate(this.navEndLabel);

    if (moveText == 1) {
      navChart.select("#brush-label-start").attr("x", navBegin + 5).text(navStartDateLabel);
      navChart.select("#brush-label-end").attr("x", navEnd - 55).text(navEndDateLabel);
    }
    else {
      navChart.select("#brush-label-start").attr("x", navBegin - 150).text(navStartDateLabel);
      navChart.select("#brush-label-end").attr("x", navEnd + 100).text(navEndDateLabel);
    }
    /************ End move brush label **********/
  }
  drawErrorChart(errorText: string) {
    let element = this.chartContainer.nativeElement;
    this.chartContainer.nativeElement.innerHTML = '';
    d3.select(element).append('svg')
      .attr('class', 'd3-chart1')
      .attr('width', element.offsetWidth + 5)
      .attr('height', element.offsetHeight)
      .append('g').append('text')
      .attr('text-anchor', 'middle')
      .attr('transform', 'translate(' + (element.offsetWidth / 2) + ',' + (element.offsetHeight / 2) + ')')
      .style('font-size', this.currentStyle.error_font_size)
      .attr('font-size', this.currentStyle.error_font_size)
      .style('fill', this.currentStyle.error_font_color)
      .attr("font-family", this.currentStyle.error_font)
      .text(this.NAME + ": " + errorText)
      .call(this.widgetHelper.textWrap);
    if (this.ERROR_TEXT_INVALID_RANGE == errorText) {
      this.logger.logWarning("TrendSeriesChart", "error while drawing line series chart. Error: " + errorText);
    }
    else {
      this.logger.logError("TrendSeriesChart", "error while drawing line series chart. Error: " + errorText);
    }
  }
  // this methods is used to get the valid zoom range
  isValidZoomRange(calculateDate: boolean, frmDate, toDate) {
    let tmpFrmDate;
    let tmpToDate;
    if (calculateDate) {
      let factor: number = (Math.abs(this.wheelDelta) / 120);
      let min = this.X_Min;
      let max = this.X_Max;
      let diff = Math.abs(max.getTime() - min.getTime());
      let clickDate = this.xScale.invert(this.mousePosX) as Date;
      let dayNumber = (diff / 100) * this.multiplierForZoom / factor;
      let NumDate: number = clickDate.getTime();
      tmpFrmDate = new Date(NumDate - dayNumber);
      tmpToDate = new Date(NumDate + dayNumber);
    }
    else {
      tmpFrmDate = frmDate;
      tmpToDate = toDate;
    }
    if ((new Date(tmpFrmDate).toString() === "Invalid Date") || (new Date(tmpToDate).toString() === "Invalid Date")) {
      return false;
    }
    if (tmpFrmDate && tmpToDate) {
      var fromdate: any = tmpFrmDate.toString();
      var todate: any = tmpToDate.toString();
      //Get milli seconds in a 5 mins      
      var unit_in_miliseconds = 60 * 1000 * this.minZoomRangeInMins;
      var difference_ms = unit_in_miliseconds;
      // Convert both dates to milliseconds
      var date_from_ms = Date.parse(fromdate);
      var date_to_ms = Date.parse(todate);
      if (date_from_ms && date_to_ms) {
        difference_ms = date_to_ms - date_from_ms;
      }
      // zoom only when zoom range is grater than 5 min
      if (difference_ms >= unit_in_miliseconds)
        return true;
      return false;
    }
    return false;
  }
  private getColor(index: number): string {
    const multiple: number = Math.floor(index / 10) * 10;
    if (index > 9) {
      index = index - multiple;
    }
    return this.colors[index];
  }
}
class TooltipValue {
  //container:any;
  xControl: any;
  yControl: any;
}
